(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8899],{

/***/ 34877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topup/[slug_name]",
      function () {
        return __webpack_require__(57622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81622:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon_la.3cd4bada.png","height":36,"width":36,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAUlEQVR42hXOu0rDYBgG4Pf7/y8HTRVaq0IX26VoJ0ERNye9BN2dvQsHB2/BUbwCBycHwd1DaQVpCwWReIolSdOYP/lsnyt4CFPS9nZB+iiPK44Igb3fAvrvGsANS7u0I2bxOHyt10hZW0UuahxXu9WW71nloWIQHUb9+ppy7QO34UBh6jlb+eqsjt6blT3OJ9WlIlGbbk2D5zSCz7R717BHvdDeHn7wPqMAgwnmO0Ph6N6FGEpFZicskKRKz//40GZguxZeJA+iXNZLBUUmBYQwUFDxpdd4G0owue+HpmwxbpNE9TBDOFW0YR6065/bzc7TsjM+yxJ+FKAFwgmzXP0Dh2tqEf8N0O4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 76912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var app_context_AppContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95513);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55784);




const HeaderCustomMobile = (param)=>{
    let { isInpage , heading , action , customIcon , customAction  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { themeApp  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(app_context_AppContext__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .I);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "md:hidden flex fixed top-0 left-0 w-full z-[50] bg-white dark:bg-bg-header h-[60px] sm:h-[70px] items-center gap-2 justify-between px-5",
            children: !isInpage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "Nunito-700 text-[24px] dark:text-white-color",
                children: heading
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-2 items-center w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        onClick: action,
                        className: "bg-bg-button dark:bg-white/10 rounded-[12px] p-[4px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            width: "24",
                            height: "25",
                            viewBox: "0 0 24 25",
                            fill: "none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M14 7.5L10 12.5L14 17.5",
                                stroke: themeApp === "dark" ? "#FFFFFF" : "#100D28",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "Nunito-700 text-[16px] dark:text-main-white flex-1 text-center",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cursor-pointer",
                        onClick: customAction,
                        children: customIcon
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderCustomMobile);


/***/ }),

/***/ 50454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ IconVoucherBold; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);

const IconVoucherBold = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.0137 13.8852C10.7456 13.8852 10.4885 13.7787 10.299 13.5892C10.1094 13.3997 10.0029 13.1426 10.0029 12.8745V7.15379C10.0029 6.88573 10.1094 6.62865 10.299 6.4391C10.4885 6.24955 10.7456 6.14307 11.0137 6.14307C11.2817 6.14307 11.5388 6.24955 11.7283 6.4391C11.9179 6.62865 12.0244 6.88573 12.0244 7.15379V12.8745C12.0244 13.1426 11.9179 13.3997 11.7283 13.5892C11.5388 13.7787 11.2817 13.8852 11.0137 13.8852Z",
                fill: "#3263E4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.15306 11.2773C8.85082 11.2773 9.41647 10.7117 9.41647 10.0139C9.41647 9.31614 8.85082 8.75049 8.15306 8.75049C7.4553 8.75049 6.88965 9.31614 6.88965 10.0139C6.88965 10.7117 7.4553 11.2773 8.15306 11.2773Z",
                fill: "#3263E4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.8738 11.2773C14.5715 11.2773 15.1372 10.7117 15.1372 10.0139C15.1372 9.31614 14.5715 8.75049 13.8738 8.75049C13.176 8.75049 12.6104 9.31614 12.6104 10.0139C12.6104 10.7117 13.176 11.2773 13.8738 11.2773Z",
                fill: "#3263E4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.61927 20C8.70761 19.9886 7.83533 19.6267 7.18342 18.9893C6.83287 18.663 6.55461 18.2669 6.36659 17.8264C6.17858 17.386 6.08498 16.911 6.09184 16.4321C6.09862 16.23 6.0635 16.0287 5.98871 15.8409C5.91391 15.653 5.80105 15.4827 5.65722 15.3406C5.51406 15.1946 5.34233 15.0798 5.15276 15.0033C4.9632 14.9268 4.75988 14.8902 4.55553 14.8958C4.07632 14.9052 3.60057 14.8128 3.15975 14.6246C2.71893 14.4364 2.32308 14.1568 1.99839 13.8042C1.65103 13.454 1.38147 13.0344 1.2073 12.5729C1.03314 12.1113 0.9583 11.6182 0.987665 11.1258C1.34142 7.28506 8.27501 0.35147 12.1057 0.00782323C12.6045 -0.0254094 13.1048 0.0474873 13.5734 0.221706C14.0421 0.395925 14.4685 0.667509 14.8245 1.01855C15.1751 1.34483 15.4533 1.74097 15.6413 2.18142C15.8294 2.62187 15.923 3.09684 15.9161 3.57569C15.912 3.77857 15.9489 3.9802 16.0246 4.16846C16.1004 4.35671 16.2134 4.52772 16.3569 4.67121C16.5004 4.8147 16.6714 4.92771 16.8596 5.00346C17.0479 5.07921 17.2495 5.11612 17.4524 5.11199C17.9321 5.0993 18.4088 5.19025 18.8501 5.37863C19.2915 5.56702 19.6869 5.8484 20.0095 6.20358C20.3478 6.55816 20.6081 6.97971 20.7735 7.44105C20.9388 7.90238 21.0057 8.39325 20.9697 8.88201C20.616 12.6722 13.6723 19.6159 9.85174 20H9.61927ZM4.56564 12.9249C5.03536 12.9262 5.50013 13.0209 5.93282 13.2037C6.36552 13.3865 6.75749 13.6536 7.08584 13.9895C7.4142 14.3254 7.67238 14.7233 7.84531 15.1601C8.01825 15.5968 8.10247 16.0636 8.09308 16.5332C8.09639 16.7237 8.13842 16.9116 8.21661 17.0853C8.2948 17.2591 8.40751 17.4151 8.5479 17.5439C8.69592 17.6906 8.87333 17.8043 9.06844 17.8774C9.26355 17.9506 9.47195 17.9816 9.67992 17.9684C12.4695 17.7057 18.6956 11.4796 18.9483 8.71018C18.9623 8.50062 18.9317 8.29047 18.8585 8.0936C18.7853 7.89673 18.6712 7.71761 18.5238 7.56806C18.395 7.42767 18.2389 7.31495 18.0652 7.23676C17.8914 7.15857 17.7036 7.11654 17.5131 7.11323C17.0369 7.13208 16.562 7.05199 16.1184 6.87802C15.6748 6.70406 15.2721 6.43999 14.9357 6.10251C14.6029 5.7648 14.3418 5.3633 14.1681 4.92212C13.9944 4.48095 13.9117 4.00921 13.925 3.53526C13.9217 3.34475 13.8796 3.15691 13.8014 2.98315C13.7232 2.80939 13.6105 2.65336 13.4701 2.52453C13.3207 2.37991 13.143 2.26759 12.9483 2.19456C12.7535 2.12153 12.5458 2.08935 12.3381 2.10003C9.54852 2.36282 3.32244 8.58889 3.06976 11.3583C3.05098 11.5689 3.07833 11.7811 3.14989 11.9801C3.22146 12.1791 3.33553 12.3601 3.48416 12.5105C3.74979 12.7868 4.11193 12.9498 4.49489 12.9653L4.56564 12.9249Z",
                fill: "#3263E4"
            })
        ]
    });
};


/***/ }),

/***/ 76633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ UpdatePhoneModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/ui/dialog.tsx
var dialog = __webpack_require__(76500);
// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./node_modules/jwt-decode/build/esm/index.js
var esm = __webpack_require__(61202);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var dist_esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./public/img/store/update-policy.png
/* harmony default export */ var update_policy = ({"src":"/_next/static/media/update-policy.fbb0c931.png","height":97,"width":97,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA/ElEQVR42jWIvU4CQRhF78fMMiQaYzRIogmNP4ktlYaOaGHDS9jzADY+gQVWPoGFjdUmFgZjD1ELCwtYd4kIWUJYQlZ3x5lPtuDc4twcZLgeU+buWJ+8DXQ1+62Ac5llKzROrUjai/jUETj8SqDuepzUytRuvsQSS9i/aE7b+53x89F70mlcLbts9KLKNdbm0Md7g1G5wj8Gm+LWh8sHdfpcJXcU87YCSsMHFPqXxsE6/MK56O7UMZkx6Ol7aHnyyHm1i4+wT1IIbKxsMThAbKpE996Mi1aDSSD9s0iNRW4xay2CuYW8efXOStLJT381KwBkGJE2UCQo1Gn6D8i5dAWh6i41AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./app/containers/topup/detail/UpdatePhoneModal.tsx








const UpdatePhoneModal = (param)=>{
    let { visible , setVisible , callback  } = param;
    const { t  } = (0,dist_esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const accessToken = configs/* isClient */.C5 ? window.localStorage.getItem("token") : null;
    const dataFromToken = (0,esm/* jwtDecode */.o)(accessToken || "");
    const onSubmit = ()=>{
        var _dataFromToken_data;
        router.push("https://id.gamota.com/authorize?access_token=".concat(dataFromToken === null || dataFromToken === void 0 ? void 0 : (_dataFromToken_data = dataFromToken.data) === null || _dataFromToken_data === void 0 ? void 0 : _dataFromToken_data.id, "&callback=/user/update_phone&redirect=").concat(callback ? callback : window.location.href, "?update=1"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.Vq, {
        open: visible,
        onOpenChange: ()=>{
            setVisible(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
            className: "sm:rounded-[16px] rounded-[16px] max-w-[90vw] md:max-w-[480px] p-[24px] border-0 focus-visible:outline-none dark:bg-bg-02",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: update_policy.src,
                    alt: "update",
                    className: "mx-auto"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-center Nunito-700 text-[20px] pt-[16px] text-black dark:text-white",
                    children: t("store.update_phone_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-center px-[12px]",
                    children: t("store.update_phone_desc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between mt-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "none",
                            className: "text-base bg-bg-button text-neutral-05 Nunito-700 rounded-[16px] dark:text-main-white dark:bg-[#ECECEE1A]",
                            autoFocus: false,
                            onClick: ()=>setVisible(false),
                            children: t("common.later")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            variant: "main",
                            className: "text-base text-white bg-main-01 Nunito-700 rounded-[16px] dark:bg-[#DAD9FE4D] dark:text-white",
                            onClick: onSubmit,
                            children: t("store.update_phone_now")
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 74046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O3": function() { return /* reexport */ useMutationDoLaCharging; },
  "sA": function() { return /* reexport */ useQueryGeGameTopupDetail; },
  "$r": function() { return /* reexport */ useQueryGetLaTransaction; },
  "dX": function() { return /* reexport */ useQueryGetListRoleTopup; },
  "Rt": function() { return /* reexport */ useQueryGetListServerTopup; },
  "Qi": function() { return /* reexport */ useQueryGetListTopup; }
});

// UNUSED EXPORTS: checkPinFn, useQueryCheckPin

// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js
var modern_useQuery = __webpack_require__(78551);
// EXTERNAL MODULE: ./app/services/services/TopupService.ts
var services_TopupService = __webpack_require__(74617);
;// CONCATENATED MODULE: ./app/services/query-fn/topup/topup-home-query.ts



const getListTopupFn = async ()=>{
    const data = await services_TopupService/* default.getListGame */.Z.getListGame();
    return data.data.data;
};
const getTopupLaTransactionFn = async (transaction_id)=>{
    const data = await services_TopupService/* default.getLaTransaction */.Z.getLaTransaction(transaction_id);
    return data.data.data;
};
const getGameTopupDetailFn = async (slug_name)=>{
    const data = await services_TopupService/* default.getInfoGameDetail */.Z.getInfoGameDetail(slug_name);
    return data.data.data;
};
const getListGameServerTopup = async (params)=>{
    const data = await services_TopupService/* default.getServerUserAndPlatformByUserId */.Z.getServerUserAndPlatformByUserId(params);
    return data.data.data;
};
const getListGameRoleTopup = async (params)=>{
    const data = await services_TopupService/* default.getRoleByServerAndUserId */.Z.getRoleByServerAndUserId(params);
    return data.data.data;
};
const checkPinFn = async ()=>{
    const data = await TopupService.checkPin();
    return data.data.data;
};
const useQueryGetListTopup = ()=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.TOPUP_LIST_GAME */.lP.TOPUP_LIST_GAME
        ],
        queryFn: ()=>getListTopupFn(),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryGeGameTopupDetail = (slug_name)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.TOPUP_GAME_DETAIL */.lP.TOPUP_GAME_DETAIL,
            slug_name
        ],
        queryFn: ()=>getGameTopupDetailFn(slug_name),
        refetchOnWindowFocus: false,
        retry: 0,
        enabled: !!slug_name
    });
};
const useQueryGetListServerTopup = (params)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.TOPUP_GAME_SERVER */.lP.TOPUP_GAME_SERVER,
            params.slug_name,
            params.user_id
        ],
        queryFn: ()=>getListGameServerTopup(params),
        refetchOnWindowFocus: false,
        retry: 0,
        enabled: !!params.slug_name && !!params.user_id
    });
};
const useQueryGetListRoleTopup = (params)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.TOPUP_GAME_ROLE */.lP.TOPUP_GAME_ROLE,
            params.slug_name,
            params.user_id,
            params.server_id
        ],
        queryFn: ()=>getListGameRoleTopup(params),
        refetchOnWindowFocus: false,
        retry: 0,
        enabled: !!params.slug_name && !!params.user_id && !!params.server_id
    });
};
const useQueryGetLaTransaction = (transaction_id)=>{
    return (0,modern_useQuery/* useQuery */.a)({
        queryKey: [
            configs/* QUERY_KEY.TOPUP_LA_TRANSACTION */.lP.TOPUP_LA_TRANSACTION
        ],
        queryFn: ()=>getTopupLaTransactionFn(transaction_id),
        refetchOnWindowFocus: false,
        retry: 0
    });
};
const useQueryCheckPin = ()=>{
    return useQuery({
        queryKey: [
            QUERY_KEY.TOPUP_CHECK_PIN
        ],
        queryFn: ()=>checkPinFn(),
        refetchOnWindowFocus: false,
        retry: 0
    });
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(98029);
;// CONCATENATED MODULE: ./app/services/query-fn/topup/topup-mutation.ts



const doLaChargingFn = (body)=>{
    return services_TopupService/* default.doLaCharge */.Z.doLaCharge(body);
};
const useMutationDoLaCharging = ()=>{
    return (0,useMutation/* useMutation */.D)({
        mutationKey: [
            configs/* QUERY_KEY.TOPUP_DO_LA_CHARGING */.lP.TOPUP_DO_LA_CHARGING
        ],
        mutationFn: doLaChargingFn
    });
};

;// CONCATENATED MODULE: ./app/services/query-fn/topup/index.ts




/***/ }),

/***/ 57622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_name_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(55784);
;// CONCATENATED MODULE: ./public/img/store/maintain.png
/* harmony default export */ var maintain = ({"src":"/_next/static/media/maintain.7c2f6dc5.png","height":265,"width":265,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA7klEQVR42mMAgSmVPFIZ7AwKDAwMPAzo4MZiBt1ri5g6WGM64ox8IrwZGBi4oFKMYPLVNt0lj45vPr9t+qQLjYt3bKxduBJsyprNe5kutDEwMnw84H/qzs07Z07Nr7iwd1rVLgYGBmYUK74dYDj4eG3+md0Lppw7sOvAtmPnrvjuvnjHNPL/f85t+QzaDI93CJT+2cdw/+HBdSdurZt27szJE1ev7tt08e367M335zG0gB1zd6dn54utEbf+bmS4cvvwqku/1jHcfL+OYd30KW7CcKvub2DwerFHqev5bttJt7fYJTPYObMxMDAwAACz7meUhaOLBAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./app/components/maintain-screen/index.tsx




const MaintainScreen = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-[1280px] mx-auto min-h-[90dvh] md:min-h-0 flex flex-col mt-[40px] mx-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: maintain,
                alt: "maintain",
                width: 265,
                height: 265,
                className: "mx-auto"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[96px] text-center Nunito-700 text-[#3263E4] xs:text-[40px]",
                children: "Opps !"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-center text-[#28253E] Nunito-500 text-[30px] xs:text-[24px]",
                children: [
                    "Cổng thanh to\xe1n cho game hiện đang bảo tr\xec. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Vui l\xf2ng quay lại sau."
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/ui/use-toast.ts
var use_toast = __webpack_require__(2786);
// EXTERNAL MODULE: ./app/services/services/TopupService.ts
var TopupService = __webpack_require__(74617);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 41 modules
var esm = __webpack_require__(93378);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./app/components/ui/input.tsx
var input = __webpack_require__(78634);
// EXTERNAL MODULE: ./app/components/ui/button.tsx
var ui_button = __webpack_require__(34428);
// EXTERNAL MODULE: ./app/components/loading-btn/index.tsx + 2 modules
var loading_btn = __webpack_require__(25327);
// EXTERNAL MODULE: ./app/components/ui/select.tsx + 2 modules
var ui_select = __webpack_require__(12998);
;// CONCATENATED MODULE: ./app/containers/topup/topup.constant.ts
const TOPUP_STEP = {
    CONFIRM_ID: 1,
    PACKAGE_METHOD: 2,
    CHECKOUT: 3
};

// EXTERNAL MODULE: ./app/hooks/useGAEventsTracker.ts
var useGAEventsTracker = __webpack_require__(64800);
// EXTERNAL MODULE: ./app/utils/index.tsx
var utils = __webpack_require__(90752);
// EXTERNAL MODULE: ./app/context/index.ts + 2 modules
var context = __webpack_require__(17986);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconClose.tsx
var IconClose = __webpack_require__(51337);
;// CONCATENATED MODULE: ./app/containers/topup/detail/LoadingTopup.tsx


const LoadingTopup = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full flex items-center justify-center mt-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    "aria-hidden": "true",
                    className: "w-10 h-10 text-gray-200 animate-spin fill-main-color",
                    viewBox: "0 0 100 101",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                            fill: "#3263E4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                            fill: "#DAD9FE"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base text-main-01 mt-1",
                    children: "Loading..."
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js + 1 modules
var createLucideIcon = __webpack_require__(84297);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/search.js
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const Search = (0,createLucideIcon/* default */.Z)("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);


//# sourceMappingURL=search.js.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-down.js
var chevron_down = __webpack_require__(8971);
;// CONCATENATED MODULE: ./app/containers/topup/detail/ConfirmIdStep.tsx


















const ConfirmIdStep = (param)=>{
    let { gameDetail , selectedData , setSelectedData , setSourcePackageAndTab , setSelectedTab , setStep , handleSetExtendData , setListPackageType  } = param;
    var _selectedData_selectServer, _selectedData_selectUser, _selectedData_selectPlatform, _gameDetail_last_transaction, _router_query;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const router = (0,next_router.useRouter)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const [userID, setUserID] = (0,react.useState)("");
    const [listServer, setListServer] = (0,react.useState)([]);
    const [listPlatform, setListPlatform] = (0,react.useState)([]);
    const [role, setRole] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const [errorInputValue, setErrorInputValue] = (0,react.useState)("");
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Store_TopupGame");
    const OptionRole = role.map((item)=>{
        return {
            title: item === null || item === void 0 ? void 0 : item.role_name,
            value: item === null || item === void 0 ? void 0 : item.role_id
        };
    });
    const OptionCountry = (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.country_list) ? Object.entries(gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.country_list).map((param)=>{
        let [key, value] = param;
        return {
            value: key,
            title: value
        };
    }) : [];
    (0,react.useEffect)(()=>{
        if (router.query.slug_name) {
            setListServer([]);
            setListPlatform([]);
            setRole([]);
            setSelectedData(initSelectedData);
        }
    }, [
        router,
        setSelectedData
    ]);
    const disablebtn = ()=>{
        if (!userID) {
            return true;
        } else {
            if (selectedData.selectRole.role_id && selectedData.selectServer.server_id) {
                return false;
            }
            if (!listServer.length) {
                return false;
            }
            return true;
        }
    };
    (0,react.useEffect)(()=>{
        var _selectedData_selectServer, _selectedData_selectUser, _router_query;
        if (!!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id) && !!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id) && (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name) !== "napla") {
            if ((listPlatform === null || listPlatform === void 0 ? void 0 : listPlatform.length) > 0) {
                var _selectedData_selectPlatform;
                if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform = selectedData.selectPlatform) === null || _selectedData_selectPlatform === void 0 ? void 0 : _selectedData_selectPlatform.platform_id) {
                    var _router_query1, _selectedData_selectServer1, _selectedData_selectUser1, _selectedData_selectPlatform1;
                    getRoleByServerAndUserId(String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.slug_name), selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer1 = selectedData.selectServer) === null || _selectedData_selectServer1 === void 0 ? void 0 : _selectedData_selectServer1.server_id, selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser1 = selectedData.selectUser) === null || _selectedData_selectUser1 === void 0 ? void 0 : _selectedData_selectUser1.user_id, selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform1 = selectedData.selectPlatform) === null || _selectedData_selectPlatform1 === void 0 ? void 0 : _selectedData_selectPlatform1.platform_id);
                }
            } else {
                var _router_query2, _selectedData_selectServer2, _selectedData_selectUser2;
                getRoleByServerAndUserId(String(router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.slug_name), selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer2 = selectedData.selectServer) === null || _selectedData_selectServer2 === void 0 ? void 0 : _selectedData_selectServer2.server_id, selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser2 = selectedData.selectUser) === null || _selectedData_selectUser2 === void 0 ? void 0 : _selectedData_selectUser2.user_id);
            }
        }
    }, [
        selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id,
        selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id,
        selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform = selectedData.selectPlatform) === null || _selectedData_selectPlatform === void 0 ? void 0 : _selectedData_selectPlatform.platform_id,
        listPlatform,
        router
    ]);
    const onChangeText = (e)=>{
        var _selectedData_selectUser, _selectedData_selectUser1, _e_target;
        if (!!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id) && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser1 = selectedData.selectUser) === null || _selectedData_selectUser1 === void 0 ? void 0 : _selectedData_selectUser1.user_id) !== (e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value)) {
            var _e_target1;
            setListServer([]);
            setListPlatform([]);
            setRole([]);
            setSelectedData(initSelectedData);
            setUserID(e === null || e === void 0 ? void 0 : (_e_target1 = e.target) === null || _e_target1 === void 0 ? void 0 : _e_target1.value);
        } else {
            var _e_target2, _e_target3;
            setUserID(e === null || e === void 0 ? void 0 : (_e_target2 = e.target) === null || _e_target2 === void 0 ? void 0 : _e_target2.value);
            if ((e === null || e === void 0 ? void 0 : (_e_target3 = e.target) === null || _e_target3 === void 0 ? void 0 : _e_target3.value) === "") {
                setSelectedData({
                    ...selectedData,
                    selectUser: {
                        user_id: "",
                        username: ""
                    }
                });
                setRole([]);
                setListServer([]);
                setListPlatform([]);
            }
        }
        setErrorInputValue("");
    };
    const submitGetRole = (e)=>{
        if (!(userID === null || userID === void 0 ? void 0 : userID.trim())) {
            setErrorInputValue(t("topup.error_select_userid", {
                value: (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.is_copub) === "yes" ? "User Id" : "Gamota Username"
            }));
        }
        if (e.keyCode == 13 && !!userID.trim()) {
            var _router_query;
            getServerUserAndPlatformByUserId({
                slug_name: String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name),
                user_id: userID === null || userID === void 0 ? void 0 : userID.trim()
            });
        }
    };
    // chọn xong user_id thì get về server_id và platform
    const getServerUserAndPlatformByUserId = async (params)=>{
        try {
            var _res_data;
            setLoading(true);
            const res = await TopupService/* default.getServerUserAndPlatformByUserId */.Z.getServerUserAndPlatformByUserId(params);
            if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                var _res_data1, _res_data_data, _res_data_data_user;
                GAEventsTracker("Store_Topup_IDinput", "Search User info");
                if (res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : (_res_data_data = _res_data1.data) === null || _res_data_data === void 0 ? void 0 : (_res_data_data_user = _res_data_data.user) === null || _res_data_data_user === void 0 ? void 0 : _res_data_data_user.user_id) {
                    var _res_data2;
                    const data = res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : _res_data2.data;
                    setSelectedData({
                        ...selectedData,
                        selectUser: data === null || data === void 0 ? void 0 : data.user
                    });
                    setListServer(()=>{
                        return Object.entries(data === null || data === void 0 ? void 0 : data.servers).map((param)=>{
                            let [server_id, server_name] = param;
                            return {
                                title: server_name,
                                value: server_id
                            };
                        });
                    });
                    if (data === null || data === void 0 ? void 0 : data.platform) {
                        var _data_platform;
                        setListPlatform(()=>{
                            return Object.entries((_data_platform = data === null || data === void 0 ? void 0 : data.platform) !== null && _data_platform !== void 0 ? _data_platform : {}).map((param)=>{
                                let [platform_id, platform_name] = param;
                                return {
                                    title: platform_name,
                                    value: platform_id
                                };
                            });
                        });
                    }
                } else {
                    setErrorInputValue(t("profile.no_data"));
                }
            } else {
                var _res_data3;
                toast({
                    title: (res === null || res === void 0 ? void 0 : (_res_data3 = res.data) === null || _res_data3 === void 0 ? void 0 : _res_data3.message) || t("message.DEFAULT_ERROR"),
                    variant: "error"
                });
            }
            setLoading(false);
        } catch (err) {
            var _err_data, _err_response, _err_response_data;
            toast({
                title: (err === null || err === void 0 ? void 0 : (_err_data = err.data) === null || _err_data === void 0 ? void 0 : _err_data.message) || (err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message) || t("message.DEFAULT_ERROR"),
                variant: "error"
            });
        } finally{
            setLoading(false);
        }
    };
    // khi chọn user_id và server_id thì get về role_id
    const getRoleByServerAndUserId = async (slug_name, server_id, user_id, platform)=>{
        setLoading(true);
        try {
            var _res_data, _res_data1;
            const param = platform ? {
                slug_name,
                server_id,
                user_id,
                platform
            } : {
                slug_name,
                server_id,
                user_id
            };
            const res = await TopupService/* default.getRoleByServerAndUserId */.Z.getRoleByServerAndUserId(param);
            if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                var _res_data2, _res_data3;
                setRole(res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : _res_data2.data);
                setSelectedData({
                    ...selectedData,
                    selectRole: res === null || res === void 0 ? void 0 : (_res_data3 = res.data) === null || _res_data3 === void 0 ? void 0 : _res_data3.data[0]
                });
            } else toast({
                title: res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : _res_data1.message,
                variant: "error"
            });
            setLoading(false);
        } catch (err) {
            var _err_data, _err_response, _err_response_data;
            var _err_data_message, _ref;
            setErrorInputValue((_ref = (_err_data_message = err === null || err === void 0 ? void 0 : (_err_data = err.data) === null || _err_data === void 0 ? void 0 : _err_data.message) !== null && _err_data_message !== void 0 ? _err_data_message : err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message) !== null && _ref !== void 0 ? _ref : t("message.DEFAULT_ERROR"));
        } finally{
            setLoading(false);
        }
    };
    const SelectInput = (param)=>{
        let { listItem , title , placeholder , onSelect , value , classname , enableSearch =false  } = param;
        const [searchTerm, setSearchTerm] = (0,react.useState)("");
        const [isOpen, setIsOpen] = (0,react.useState)(false);
        const searchInputRef = (0,react.useRef)(null);
        const dropdownRef = (0,react.useRef)(null);
        const filteredItems = (0,react.useMemo)(()=>{
            if (!enableSearch || !searchTerm) return listItem || [];
            return (listItem || []).filter((item)=>{
                var _item_title;
                return (_item_title = item.title) === null || _item_title === void 0 ? void 0 : _item_title.toLowerCase().includes(searchTerm.toLowerCase());
            });
        }, [
            listItem,
            searchTerm,
            enableSearch
        ]);
        const selectedItem = listItem === null || listItem === void 0 ? void 0 : listItem.find((item)=>item.value === value);
        (0,react.useEffect)(()=>{
            if (!isOpen) {
                setSearchTerm("");
            }
        }, [
            isOpen
        ]);
        (0,react.useEffect)(()=>{
            if (isOpen && enableSearch && searchInputRef.current) {
                setTimeout(()=>{
                    var _searchInputRef_current;
                    (_searchInputRef_current = searchInputRef.current) === null || _searchInputRef_current === void 0 ? void 0 : _searchInputRef_current.focus();
                }, 100);
            }
        }, [
            isOpen,
            enableSearch
        ]);
        (0,react.useEffect)(()=>{
            const handleClickOutside = (event)=>{
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setIsOpen(false);
                }
            };
            if (isOpen) {
                document.addEventListener("mousedown", handleClickOutside);
            }
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            isOpen
        ]);
        const handleItemSelect = (item)=>{
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(item.value);
            setIsOpen(false);
            setSearchTerm("");
        };
        const handleInputKeyDown = (e)=>{
            if (e.key === "Escape") {
                setIsOpen(false);
            } else if (e.key === "ArrowDown") {
                var _dropdownRef_current;
                e.preventDefault();
                const firstItem = (_dropdownRef_current = dropdownRef.current) === null || _dropdownRef_current === void 0 ? void 0 : _dropdownRef_current.querySelector("[data-item]");
                firstItem === null || firstItem === void 0 ? void 0 : firstItem.focus();
            }
        };
        const handleItemKeyDown = (e, item)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleItemSelect(item);
            }
        };
        if (!enableSearch) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[24px] ".concat(classname),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "text-[16px] pb-[8px] pl-[24px]",
                        children: [
                            title,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                        onValueChange: onSelect,
                        value: value,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectTrigger */.i4, {
                                className: "h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 dark:bg-white/10 text-[16px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                    placeholder: placeholder
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                children: listItem === null || listItem === void 0 ? void 0 : listItem.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                        value: item === null || item === void 0 ? void 0 : item.value,
                                        className: "p-3 hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }, item === null || item === void 0 ? void 0 : item.value);
                                })
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-[24px] ".concat(classname),
            ref: dropdownRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-[16px] pb-[8px] pl-[24px]",
                    children: [
                        title,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 dark:bg-white/10 text-[16px] bg-white dark:bg-gray-800 cursor-text flex items-center",
                            onClick: ()=>setIsOpen(true),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                                    className: "h-4 w-4 mr-3 flex-shrink-0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ref: searchInputRef,
                                    type: "text",
                                    placeholder: selectedItem ? selectedItem.title : placeholder,
                                    value: searchTerm,
                                    onChange: (e)=>{
                                        setSearchTerm(e.target.value);
                                        if (!isOpen) setIsOpen(true);
                                    },
                                    onKeyDown: handleInputKeyDown,
                                    onFocus: ()=>setIsOpen(true),
                                    className: "flex-1 outline-none text-[16px] text-black placeholder:text-black"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down/* default */.Z, {
                                    className: "h-4 w-4 transition-transform ".concat(isOpen ? "rotate-180" : "")
                                })
                            ]
                        }),
                        isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-full left-0 right-0 mt-1 bg-white dark:bg-gray-800 border border-black/10 rounded-[16px] shadow-lg z-50 max-h-80 overflow-hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-h-48 overflow-y-auto",
                                children: (searchTerm ? filteredItems : listItem || []).length > 0 ? (searchTerm ? filteredItems : listItem || []).map((item, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        "data-item": true,
                                        tabIndex: 0,
                                        className: "p-3 hover:bg-bg-disable hover:text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:bg-[#F1F1FC]/[.1] dark:focus:bg-[#F1F1FC]/[.1] cursor-pointer outline-none",
                                        onClick: ()=>handleItemSelect(item),
                                        onKeyDown: (e)=>handleItemKeyDown(e, item),
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }, (item === null || item === void 0 ? void 0 : item.value) || index);
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "p-3 text-center text-sm",
                                    children: searchTerm ? "Kh\xf4ng t\xecm thấy kết quả" : "Kh\xf4ng c\xf3 dữ liệu"
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    //lọc ra các tab game không có package nào Active
    const filterTabGames = (packageAndTab)=>{
        var _packageAndTab_tabGame;
        if ((packageAndTab === null || packageAndTab === void 0 ? void 0 : packageAndTab.tabGame) && (packageAndTab === null || packageAndTab === void 0 ? void 0 : (_packageAndTab_tabGame = packageAndTab.tabGame) === null || _packageAndTab_tabGame === void 0 ? void 0 : _packageAndTab_tabGame.length) > 0) {
            var _packageAndTab_tabGame1;
            const _filterList = packageAndTab === null || packageAndTab === void 0 ? void 0 : (_packageAndTab_tabGame1 = packageAndTab.tabGame) === null || _packageAndTab_tabGame1 === void 0 ? void 0 : _packageAndTab_tabGame1.filter((tab)=>{
                const filterObject = Object.fromEntries(Object.entries(packageAndTab === null || packageAndTab === void 0 ? void 0 : packageAndTab.packages).filter((param)=>{
                    let [key] = param;
                    return tab.package.includes(key);
                }));
                const _package = (0,utils/* convertObjectToArray */.HS)(filterObject);
                if (_package === null || _package === void 0 ? void 0 : _package.length) {
                    return true;
                }
                return false;
            });
            return _filterList;
        }
        return [];
    };
    // khi đủ role_id và server_id thì get list package và tablist
    const getSourcePackageAndTab = async (slug_name, user_id, server_id, role_id, platform)=>{
        setLoading(true);
        try {
            var _selectedData_selectUser, _selectedData_selectServer, _selectedData_selectRole, _selectedData_selectPlatform, _res_data;
            const res = await TopupService/* default.getSourcePackageAndTab */.Z.getSourcePackageAndTab({
                slug_name,
                user_id: user_id ? user_id : selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id,
                server_id: server_id ? server_id : selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id,
                role_id: role_id ? role_id : selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole = selectedData.selectRole) === null || _selectedData_selectRole === void 0 ? void 0 : _selectedData_selectRole.role_id,
                platform: platform ? platform : selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform = selectedData.selectPlatform) === null || _selectedData_selectPlatform === void 0 ? void 0 : _selectedData_selectPlatform.platform_id
            });
            if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                var _res_data1;
                const data = res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : _res_data1.data;
                if (!!(data === null || data === void 0 ? void 0 : data.extendData)) {
                    handleSetExtendData(data === null || data === void 0 ? void 0 : data.extendData);
                }
                const listTabGames = filterTabGames(data);
                setSourcePackageAndTab({
                    ...data,
                    tabGame: listTabGames
                });
                if (!!(data === null || data === void 0 ? void 0 : data.tabGame)) {
                    setSelectedTab(listTabGames[0]);
                }
                if (data === null || data === void 0 ? void 0 : data.list_package_type) {
                    setListPackageType(data === null || data === void 0 ? void 0 : data.list_package_type);
                }
                setStep(TOPUP_STEP.PACKAGE_METHOD);
            } else {
                var _res_data2;
                toast({
                    title: res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : _res_data2.message,
                    variant: "error"
                });
            }
        } catch (err) {
            var _err_data, _err_response, _err_response_data;
            var _err_data_message;
            toast({
                title: (_err_data_message = err === null || err === void 0 ? void 0 : (_err_data = err.data) === null || _err_data === void 0 ? void 0 : _err_data.message) !== null && _err_data_message !== void 0 ? _err_data_message : err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message,
                variant: "error"
            });
        } finally{
            setLoading(false);
        }
    };
    // khi đủ role_id và server_id thì get list package và tablist
    const getSourcePackageAndTabInOpenGlobal = async (slug_name)=>{
        setLoading(true);
        try {
            var _res_data;
            const res = await TopupService/* default.getSourcePackageAndTabInOpenGlobal */.Z.getSourcePackageAndTabInOpenGlobal({
                slug_name,
                country_code: (selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) || ""
            });
            if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                var _res_data1;
                const data = res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : _res_data1.data;
                if (!!(data === null || data === void 0 ? void 0 : data.extendData)) {
                    handleSetExtendData(data === null || data === void 0 ? void 0 : data.extendData);
                }
                const listTabGames = filterTabGames(data);
                setSourcePackageAndTab({
                    ...data,
                    tabGame: listTabGames
                });
                if (!!(data === null || data === void 0 ? void 0 : data.tabGame)) {
                    setSelectedTab(listTabGames[0]);
                }
                if (data === null || data === void 0 ? void 0 : data.list_package_type) {
                    setListPackageType(data === null || data === void 0 ? void 0 : data.list_package_type);
                }
                setStep(TOPUP_STEP.PACKAGE_METHOD);
            } else {
                var _res_data2;
                toast({
                    title: res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : _res_data2.message,
                    variant: "error"
                });
            }
        } catch (err) {
            var _err_data, _err_response, _err_response_data;
            var _err_data_message;
            toast({
                title: (_err_data_message = err === null || err === void 0 ? void 0 : (_err_data = err.data) === null || _err_data === void 0 ? void 0 : _err_data.message) !== null && _err_data_message !== void 0 ? _err_data_message : err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.message,
                variant: "error"
            });
        } finally{
            setLoading(false);
        }
    };
    (0,react.useEffect)(()=>{
        var _gameDetail_last_transaction;
        if (!!(gameDetail === null || gameDetail === void 0 ? void 0 : (_gameDetail_last_transaction = gameDetail.last_transaction) === null || _gameDetail_last_transaction === void 0 ? void 0 : _gameDetail_last_transaction.username)) {
            var _gameDetail_last_transaction1;
            setUserID((gameDetail === null || gameDetail === void 0 ? void 0 : (_gameDetail_last_transaction1 = gameDetail.last_transaction) === null || _gameDetail_last_transaction1 === void 0 ? void 0 : _gameDetail_last_transaction1.username) || "");
        } else if ((gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.is_copub) === "no") {
            setUserID(userInfo === null || userInfo === void 0 ? void 0 : userInfo.username);
        } else {
            setUserID("");
        }
    }, [
        gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.is_copub,
        gameDetail === null || gameDetail === void 0 ? void 0 : (_gameDetail_last_transaction = gameDetail.last_transaction) === null || _gameDetail_last_transaction === void 0 ? void 0 : _gameDetail_last_transaction.username,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.username
    ]);
    (0,react.useEffect)(()=>{
        var _selectedData_selectUser, _selectedData_selectServer, _router_query;
        if (((_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id) && ((_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id) && (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name) === "napla") {
            getSourcePackageAndTab("napla", userInfo.userid, userInfo.userid, userInfo.userid);
        }
    }, [
        router,
        userInfo,
        selectedData,
        getSourcePackageAndTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:mt-[64px] md:max-w-[450px] mx-auto flex flex-col h-full w-full flex-1 pb-[48px]",
        children: ((_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name) === "napla" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingTopup, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-[16px] pb-[8px] md:pl-[24px]",
                                    children: [
                                        t("topup.input_id", {
                                            field: (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.is_copub) === "yes" ? "ID" : "Username"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative inline-block group",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[10px] flex items-center gap-1 text-main-01 font-semibold",
                                            children: (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.is_copub) === "yes" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "Hướng dẫn lấy UserID",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mb-[5px]",
                                                        dangerouslySetInnerHTML: {
                                                            __html: '\n                              <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                <g clip-path="url(#clip0_26623_141953)">\n                                  <path d="M5.70195 4.7L6.0173 4.90292L5.70195 4.7ZM3.79232 4.24967C3.79232 4.45678 3.96021 4.62467 4.16732 4.62467C4.37442 4.62467 4.54232 4.45678 4.54232 4.24967H3.79232ZM4.62565 6.12467C4.62565 6.33178 4.79354 6.49967 5.00065 6.49967C5.20776 6.49967 5.37565 6.33178 5.37565 6.12467H4.62565ZM5.37565 7.16634C5.37565 6.95923 5.20776 6.79134 5.00065 6.79134C4.79354 6.79134 4.62565 6.95923 4.62565 7.16634H5.37565ZM4.62565 7.58301C4.62565 7.79011 4.79354 7.95801 5.00065 7.95801C5.20776 7.95801 5.37565 7.79011 5.37565 7.58301H4.62565ZM9.16732 5.49967H8.79232C8.79232 7.59375 7.09473 9.29134 5.00065 9.29134V9.66634V10.0413C7.50894 10.0413 9.54232 8.00797 9.54232 5.49967H9.16732ZM5.00065 9.66634V9.29134C2.90657 9.29134 1.20898 7.59375 1.20898 5.49967H0.833984H0.458984C0.458984 8.00797 2.49236 10.0413 5.00065 10.0413V9.66634ZM0.833984 5.49967H1.20898C1.20898 3.40559 2.90657 1.70801 5.00065 1.70801V1.33301V0.958008C2.49236 0.958008 0.458984 2.99138 0.458984 5.49967H0.833984ZM5.00065 1.33301V1.70801C7.09473 1.70801 8.79232 3.40559 8.79232 5.49967H9.16732H9.54232C9.54232 2.99138 7.50894 0.958008 5.00065 0.958008V1.33301ZM5.83398 4.24967H5.45898C5.45898 4.34148 5.43238 4.42592 5.38659 4.49708L5.70195 4.7L6.0173 4.90292C6.13863 4.71437 6.20898 4.48966 6.20898 4.24967H5.83398ZM4.16732 4.24967H4.54232C4.54232 3.99654 4.74752 3.79134 5.00065 3.79134V3.41634V3.04134C4.33331 3.04134 3.79232 3.58233 3.79232 4.24967H4.16732ZM5.00065 3.41634V3.79134C5.25378 3.79134 5.45898 3.99654 5.45898 4.24967H5.83398H6.20898C6.20898 3.58233 5.668 3.04134 5.00065 3.04134V3.41634ZM5.00065 5.91634H4.62565V6.12467H5.00065H5.37565V5.91634H5.00065ZM5.70195 4.7L5.38659 4.49708C5.33608 4.57558 5.27225 4.6577 5.19514 4.75353C5.12195 4.84449 5.03372 4.95146 4.95468 5.06009C4.79924 5.27372 4.62565 5.56273 4.62565 5.91634H5.00065H5.37565C5.37565 5.80971 5.42818 5.68408 5.56114 5.50135C5.62629 5.41181 5.69782 5.32518 5.77947 5.2237C5.8572 5.1271 5.94329 5.01794 6.0173 4.90292L5.70195 4.7ZM5.00065 7.16634H4.62565V7.58301H5.00065H5.37565V7.16634H5.00065Z" fill="#3263E4"/>\n                                </g>\n                                <defs>\n                                  <clipPath id="clip0_26623_141953">\n                                    <rect width="10" height="10" fill="white" transform="translate(0 0.5)"/>\n                                  </clipPath>\n                                </defs>\n                              </svg>\n                            '
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.guide_img) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "absolute overflow-visible min-w-fit right-[10px] lg:right-auto lg:left-[40px] bottom-6 z-10 scale-0 group-hover:scale-100 transition-all duration-200 origin-bottom",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-2 h-2 bg-white shadow-2xl rotate-45 absolute bottom-[-6px] right-[20px] lg:right-auto lg:left-[62px] z-0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative p-[2px] bg-white rounded-md border border-input-border-light shadow-lg z-10",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.guide_img,
                                                        alt: "Hướng dẫn UserID",
                                                        className: "rounded-md shadow-lg border min-w-[350px] sm:min-w-[400px] lg:min-w-[500px] xl:min-w-[550px] "
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                    onBlur: submitGetRole,
                                    placeholder: t("topup.input_user_id", {
                                        field: (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.is_copub) === "yes" ? "User ID" : "Gamota Username"
                                    }),
                                    className: "h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 text-[16px] dark:bg-white/10",
                                    onChange: onChangeText,
                                    onKeyDown: submitGetRole,
                                    value: userID === null || userID === void 0 ? void 0 : userID.trim()
                                }),
                                !!userID && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* IconClose */.b, {
                                    className: "absolute cursor-pointer top-[35%] w-[16px] h-[16px] right-[16px]",
                                    onClick: ()=>{
                                        setUserID("");
                                    }
                                })
                            ]
                        }),
                        errorInputValue != "Server incorrect" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xs text-main-red Nunito-400 absolute -bottom-4 pl-[6px]",
                            children: errorInputValue
                        })
                    ]
                }),
                !!(listServer === null || listServer === void 0 ? void 0 : listServer.length) && (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.open_global) === "yes" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[343px] w-full mx-auto mt-[24px] border border-dashed border-black/10 dark:border-white/10 h-[1.5px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInput, {
                            listItem: OptionCountry,
                            title: t("store.select_country"),
                            placeholder: t("store.select_country"),
                            value: (selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) || "",
                            onSelect: (value)=>{
                                setSelectedData({
                                    ...selectedData,
                                    country_code: value
                                });
                            },
                            enableSearch: true
                        })
                    ]
                }),
                !!(listServer === null || listServer === void 0 ? void 0 : listServer.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInput, {
                        listItem: listServer,
                        title: t("topup.server"),
                        enableSearch: true,
                        placeholder: t("topup.server"),
                        value: selectedData.selectServer.server_id,
                        onSelect: (value)=>{
                            var _listServer_find;
                            GAEventsTracker("Store_Topup_Selectserver", "Search User info");
                            var _listServer_find_title;
                            setSelectedData({
                                ...selectedData,
                                selectServer: {
                                    server_id: value,
                                    server_name: (_listServer_find_title = (_listServer_find = listServer === null || listServer === void 0 ? void 0 : listServer.find((item)=>{
                                        return (item === null || item === void 0 ? void 0 : item.value) === value;
                                    })) === null || _listServer_find === void 0 ? void 0 : _listServer_find.title) !== null && _listServer_find_title !== void 0 ? _listServer_find_title : ""
                                }
                            });
                        }
                    })
                }),
                !!(listPlatform === null || listPlatform === void 0 ? void 0 : listPlatform.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInput, {
                    listItem: listPlatform,
                    title: t("topup.platform"),
                    placeholder: t("topup.platform"),
                    value: selectedData.selectPlatform.platform_id,
                    onSelect: (value)=>{
                        var _listPlatform_find;
                        var _listPlatform_find_title;
                        setSelectedData({
                            ...selectedData,
                            selectPlatform: {
                                platform_id: value,
                                platform_name: (_listPlatform_find_title = (_listPlatform_find = listPlatform === null || listPlatform === void 0 ? void 0 : listPlatform.find((item)=>{
                                    return (item === null || item === void 0 ? void 0 : item.value) === value;
                                })) === null || _listPlatform_find === void 0 ? void 0 : _listPlatform_find.title) !== null && _listPlatform_find_title !== void 0 ? _listPlatform_find_title : ""
                            }
                        });
                    }
                }),
                !!(role === null || role === void 0 ? void 0 : role.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInput, {
                    listItem: OptionRole,
                    title: t("topup.name_role"),
                    placeholder: t("topup.name_role"),
                    classname: "mb-[32px] md:mb-[0px]",
                    value: selectedData.selectRole.role_id,
                    onSelect: (value)=>{
                        var _role_find;
                        setSelectedData({
                            ...selectedData,
                            selectRole: (_role_find = role === null || role === void 0 ? void 0 : role.find((item)=>{
                                return (item === null || item === void 0 ? void 0 : item.role_id) === value;
                            })) !== null && _role_find !== void 0 ? _role_find : {
                                role_id: "",
                                role_name: ""
                            }
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "main",
                    onClick: ()=>{
                        var _selectedData_selectUser;
                        if (!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id)) {
                            var _router_query;
                            getServerUserAndPlatformByUserId({
                                slug_name: String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name),
                                user_id: userID === null || userID === void 0 ? void 0 : userID.trim()
                            });
                        } else if (!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) && (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.open_global) === "yes") {
                            toast({
                                title: t("store.select_country"),
                                variant: "error"
                            });
                        } else if ((gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.open_global) === "yes" && (selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) !== "VN") {
                            getSourcePackageAndTabInOpenGlobal(gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.slug_name);
                        } else {
                            getSourcePackageAndTab(gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.slug_name);
                        }
                    },
                    disabled: disablebtn(),
                    className: "mx-auto mt-auto mb-0 md:mt-[32px] text-[14px] w-full h-[45px] leading-[19px] rounded-[16px]",
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {}) : t("reward.confirm")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./public/img/gift_icon.png
/* harmony default export */ var gift_icon = ({"src":"/_next/static/media/gift_icon.e04becc0.png","height":22,"width":22,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9klEQVR42h3OPUvDQBwH4N+9pDGFGpqO4qAggkMVFDcHF3HpZ+jgtxL0C6izY3FXKNSlOsVK0agNzZuX3N3/xO7P8LB5f18AsEUYDFhW6YLThNpoAHyJvBYMAB6xexIddG5UXT1zIbZJ23Q2zS8AjCUAsGHdS1/cb13qI497Wku71T5Th/+AvV7u9TePByNezsPiPhHQhLXzLsFUaTwdnUr4rVS9PSUsaCLJfUvUwNhE2NJ9E+tkfGc4ntFics3UJ6j6Ma7JDWUx1PvDVeQ+4tVBtHrrnAs4LnxwgDEJ4W2EALAC9XJxC8Ohi65CA8hlFljj7gDgD3x+dG8g41O1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./app/containers/topup/detail/NguyenBaoGamota.tsx



const NguyenbaoGamota = (param)=>{
    let { current , maxValue  } = param;
    const percent = current / maxValue * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full bg-[#FFFCF2] py-[16px] px-[14px] flex flex-col mt-[16px] rounded-[10px] border border-dashed border-[#F4CE78]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-between w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: gift_icon === null || gift_icon === void 0 ? void 0 : gift_icon.src,
                            width: 22,
                            height: 22,
                            className: "mr-[5px] max-w-[22px] max-h-[22px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-[#FF8900] Nunito-400 text-xs",
                            children: [
                                "Nạp Nguy\xean Bảo tặng 100% NB kh\xf3a ( tối đa ".concat(maxValue, ")"),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-[10px] text-xs",
                                    children: [
                                        "(",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-[600]",
                                            children: current === null || current === void 0 ? void 0 : current.toLocaleString()
                                        }),
                                        "/".concat(maxValue === null || maxValue === void 0 ? void 0 : maxValue.toLocaleString()),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full bg-[#FFF0C6] rounded-[20px] h-[14px] mt-[7px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-[#FF8900] h-[14px] rounded-tl-[20px] rounded-bl-[20px] ".concat(percent >= 100 ? "rounded-br-[20px] rounded-tr-[20px]" : ""),
                    style: {
                        width: "".concat(percent, "%")
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/img/gift_icon_2.png
/* harmony default export */ var gift_icon_2 = ({"src":"/_next/static/media/gift_icon_2.8b62906a.png","height":44,"width":45,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAyklEQVR42mOAge/vvzNeXbONH85ftIkRzLhY180Eos+1TjC91DdzycW5K4IuLVlvBRJ7NnslE1jRQQYGkeOh6c/ONPX9v5Bd9f9Rx/R732snicON387AoHQkNvfXyfLW3/f53f//nLDwzYUpC8XgCtYxMKgezq78fxqo+6Vj/P9v05cfAon/X3+ACaaGfUNVS9LhuNwdD31Sz92ftjgcrGDtHoiCsCePGaEKOYCYB4gZ/+88ARaDg/8rtzO9aZrE/D+xjun/2XtwowFmr1eUD3TjngAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./app/containers/topup/detail/PackageAndMethod.tsx













const PackageAndMethod = (param)=>{
    let { packageAndTab , selectedTab , handleChangeSelectedTab , selectedData , setSelectedData , setLoading , loading , renderMethods , setRenderMethods , extendData , listPackageType , gameDetail  } = param;
    var _router_query, _selectedData_selectPackage, _packageAndTab_tabGame, _packageAndTab_tabGame1, _selectedData_selectPackage1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { userInfo  } = (0,react.useContext)(context/* AppContext */.Il);
    const [renderPackage, setRenderPackage] = (0,react.useState)([]);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Store_TopupGame");
    const handleSelectRenderPackageWhenChangeTab = ()=>{
        if (!selectedTab) {
            const result = (0,utils/* convertObjectToArray */.HS)(packageAndTab === null || packageAndTab === void 0 ? void 0 : packageAndTab.packages);
            setRenderPackage(result);
            setSelectedData({
                ...selectedData,
                selectPackage: result[0]
            });
            return result;
        }
        const filterObject = Object.fromEntries(Object.entries(packageAndTab === null || packageAndTab === void 0 ? void 0 : packageAndTab.packages).filter((param)=>{
            let [key] = param;
            var _selectedTab_package;
            return selectedTab === null || selectedTab === void 0 ? void 0 : (_selectedTab_package = selectedTab.package) === null || _selectedTab_package === void 0 ? void 0 : _selectedTab_package.includes(key);
        }));
        const _package = (0,utils/* convertObjectToArray */.HS)(filterObject);
        if (_package === null || _package === void 0 ? void 0 : _package.length) {
            setRenderPackage(_package);
            const firstPackage = _package[0];
            setSelectedData({
                ...selectedData,
                selectPackage: firstPackage
            });
        }
    };
    const getMethodByPackageId = async (slug_name, v3_id)=>{
        setLoading(true);
        try {
            var _selectedData_selectUser, _selectedData_selectServer, _selectedData_selectRole;
            if (!!slug_name && !!v3_id && !!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id) && !!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id) && !!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole = selectedData.selectRole) === null || _selectedData_selectRole === void 0 ? void 0 : _selectedData_selectRole.role_id)) {
                var _selectedData_selectUser1, _selectedData_selectServer1, _selectedData_selectRole1, _selectedData_selectPlatform, _res_data;
                const res = await TopupService/* default.getMethodByPackageId */.Z.getMethodByPackageId({
                    slug_name,
                    v3_id,
                    user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser1 = selectedData.selectUser) === null || _selectedData_selectUser1 === void 0 ? void 0 : _selectedData_selectUser1.user_id,
                    server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer1 = selectedData.selectServer) === null || _selectedData_selectServer1 === void 0 ? void 0 : _selectedData_selectServer1.server_id,
                    role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole1 = selectedData.selectRole) === null || _selectedData_selectRole1 === void 0 ? void 0 : _selectedData_selectRole1.role_id,
                    platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform = selectedData.selectPlatform) === null || _selectedData_selectPlatform === void 0 ? void 0 : _selectedData_selectPlatform.platform_id
                });
                if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                    var _res_data1, _res_data_data, _res_data2, _res_data_data1;
                    const methods = (0,utils/* convertObjectToArray */.HS)((res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : (_res_data_data = _res_data1.data) === null || _res_data_data === void 0 ? void 0 : _res_data_data.methods) || {});
                    setRenderMethods([
                        ...methods
                    ]);
                    setSelectedData({
                        ...selectedData,
                        selectMethod: methods[0],
                        hoverDescription: res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : (_res_data_data1 = _res_data2.data) === null || _res_data_data1 === void 0 ? void 0 : _res_data_data1.v3_description
                    });
                }
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
        } finally{}
    };
    (0,react.useEffect)(()=>{
        handleSelectRenderPackageWhenChangeTab();
    }, [
        selectedTab,
        packageAndTab
    ]);
    (0,react.useEffect)(()=>{
        var _router_query, _selectedData_selectPackage;
        if (!!(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name) && !!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id)) {
            var _router_query1, _selectedData_selectPackage1;
            getMethodByPackageId(String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.slug_name), selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.v3_id);
        }
    }, [
        router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name,
        selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id
    ]);
    const onChangeSelectPackage = (item)=>{
        if (!loading) {
            GAEventsTracker("Store_Topup_package", "Search User info");
            setSelectedData({
                ...selectedData,
                selectPackage: item
            });
        }
    };
    const onChangeSelectMethod = (item)=>{
        if (!loading) {
            // GAEventsTracker("Store_Topup_package")
            if (item.method !== "gamota_la" || selectedData.selectPackage.v3_amount <= userInfo.total_la) setSelectedData({
                ...selectedData,
                selectMethod: item
            });
        }
    };
    var _extendData_alreadyGoldGift, _extendData_totalLimit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full lg:mb-[28px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "topup-package pb-[100px] md:pb-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[16px] Nunito-700 hidden md:block",
                        children: [
                            "1. ",
                            t("topup.select_package")
                        ]
                    }),
                    !!(packageAndTab === null || packageAndTab === void 0 ? void 0 : packageAndTab.tabGame) && (packageAndTab === null || packageAndTab === void 0 ? void 0 : (_packageAndTab_tabGame = packageAndTab.tabGame) === null || _packageAndTab_tabGame === void 0 ? void 0 : _packageAndTab_tabGame.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block mt-[12px] flex gap-[12px] flex-wrap",
                        children: !!(packageAndTab === null || packageAndTab === void 0 ? void 0 : packageAndTab.tabGame) && (packageAndTab === null || packageAndTab === void 0 ? void 0 : (_packageAndTab_tabGame1 = packageAndTab.tabGame) === null || _packageAndTab_tabGame1 === void 0 ? void 0 : _packageAndTab_tabGame1.map((tab)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "Nunito-600 text-sm w-fit px-[16px] rounded-[12px] h-[31px] ".concat((selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id) === (tab === null || tab === void 0 ? void 0 : tab.id) ? "bg-main-01 text-white" : "border border-black/10 text-main-text-color bg-white dark:bg-white/10 dark:text-white"),
                                onClick: ()=>handleChangeSelectedTab(tab),
                                children: tab === null || tab === void 0 ? void 0 : tab.name
                            }, tab === null || tab === void 0 ? void 0 : tab.id);
                        }))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    !!extendData && /*#__PURE__*/ (0,jsx_runtime.jsx)(NguyenbaoGamota, {
                        current: (_extendData_alreadyGoldGift = extendData === null || extendData === void 0 ? void 0 : extendData.alreadyGoldGift) !== null && _extendData_alreadyGoldGift !== void 0 ? _extendData_alreadyGoldGift : 0,
                        maxValue: (_extendData_totalLimit = extendData === null || extendData === void 0 ? void 0 : extendData.totalLimit) !== null && _extendData_totalLimit !== void 0 ? _extendData_totalLimit : 0
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingTopup, {}) : Array.isArray(renderPackage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full grid ".concat(listPackageType === "image" ? "grid-cols-3 sm:grid-cols-4" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-2", " gap-x-[24px] gap-y-[16px] mt-[16px]"),
                        children: [
                            renderPackage.map((item)=>{
                                var _selectedData_selectPackage, _selectedData_selectPackage1, _item_v3_amount, _item_package_amount;
                                // console.log(item?.v3_id, selectedData?.selectPackage?.v3_id)
                                const is_selected = (item === null || item === void 0 ? void 0 : item.v3_id) === (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id) && !!(item === null || item === void 0 ? void 0 : item.v3_id) || (item === null || item === void 0 ? void 0 : item.package_id) === (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.package_id) && !!(item === null || item === void 0 ? void 0 : item.package_id);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>{
                                        onChangeSelectPackage(item);
                                    },
                                    className: "".concat(is_selected ? "border border-[1px] border-main-01 dark:border-color-border text-main-01" : "dark:bg-block-color dark:border-white/10 border border-white border-[1px]", " ").concat(listPackageType === "image" ? "overflow-hidden" : "px-[16px] py-[14px]", " rounded-[12px] cursor-pointer flex items-center bg-white dark:bg-white/10"),
                                    children: listPackageType === "image" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.v3_image || item.image_url,
                                        alt: (item === null || item === void 0 ? void 0 : item.v3_title) || (item === null || item === void 0 ? void 0 : item.package_title),
                                        className: "w-full aspect-square"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            is_selected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        width: "16",
                                                        height: "16",
                                                        rx: "8",
                                                        fill: "#3263E4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M11.7509 5.22127C11.9048 5.35982 11.9173 5.59692 11.7787 5.75087L7.90995 10.0495C7.42268 10.5909 6.59774 10.6584 6.02896 10.2034L4.26575 8.79283C4.10403 8.66345 4.07781 8.42747 4.20719 8.26574C4.33657 8.10402 4.57255 8.0778 4.73427 8.20718L6.49749 9.61775C6.75602 9.82458 7.13099 9.7939 7.35248 9.54781L11.2213 5.24914C11.3598 5.0952 11.5969 5.08272 11.7509 5.22127Z",
                                                        fill: "#FAF8FF"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[16px] h-[16px] rounded-[16px] bg-button"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[14px] Nunito-700 ml-[16px] flex-1 mr-2",
                                                children: (item === null || item === void 0 ? void 0 : item.v3_title) || (item === null || item === void 0 ? void 0 : item.package_title)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "ml-auto mr-0 ".concat(is_selected ? "text-main-red-02" : "text-main-red-02 dark:text-main-white", " text-[16px] Nunito-700 whitespace-nowrap dark:bg-white/10 dark:px-[12px] dark:py-[4px] dark:rounded-[8px]"),
                                                children: [
                                                    (item === null || item === void 0 ? void 0 : item.v3_amount) && "đ ".concat(item === null || item === void 0 ? void 0 : (_item_v3_amount = item.v3_amount) === null || _item_v3_amount === void 0 ? void 0 : _item_v3_amount.toLocaleString()),
                                                    (item === null || item === void 0 ? void 0 : item.package_amount) && "".concat(item === null || item === void 0 ? void 0 : (_item_package_amount = item.package_amount) === null || _item_package_amount === void 0 ? void 0 : _item_package_amount.toLocaleString(), " ").concat(item === null || item === void 0 ? void 0 : item.currency)
                                                ]
                                            })
                                        ]
                                    })
                                }, (item === null || item === void 0 ? void 0 : item.v3_id) || (item === null || item === void 0 ? void 0 : item.package_id));
                            }),
                            listPackageType === "image" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: ()=>{
                                    router.push("/giftcode?game_id=".concat(gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.game_id, "&type=game"));
                                },
                                className: "w-full h-full bg-qua-tro-luc-image rounded-[12px] overflow-hidden cursor-pointer aspect-square"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: ()=>{
                                    router.push("/giftcode?game_id=".concat(gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.game_id, "&type=game"));
                                },
                                className: "bg-qua-tro-luc flex items-center gap-[6px] dark:bg-block-color dark:border-white/10 border border-white border-[1px] px-[16px] py-[14px] rounded-[12px] cursor-pointer flex items-center bg-white dark:bg-white/10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: gift_icon_2,
                                        alt: "gift",
                                        width: 32,
                                        height: 32
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-white Nunito-700 text-[14px]",
                                        children: t("store.power_gift")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.v3_id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "package-method mt-[28px] lg:my-[28px] hidden md:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[16px] Nunito-700 pb-[16px] hidden md:block",
                        children: [
                            "2. ",
                            t("topup.select_method")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full grid grid-cols-1 gap-[16px] lg:mb-[100px]",
                        children: !!Array.isArray(renderMethods) && renderMethods.slice().sort((a, b)=>b.order - a.order).map((item)=>{
                            var _selectedData_selectMethod, _selectedData_selectPackage, _userInfo_total_la, _selectedData_selectPackage1, _item_item, _item_item_amount, _item_item1, _item_item2, _item_item3, _selectedData_selectPackage2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                onClick: ()=>{
                                    onChangeSelectMethod(item);
                                },
                                className: "".concat((item === null || item === void 0 ? void 0 : item.method) === (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : _selectedData_selectMethod.method) ? "border-[1px] px-[24px] border-main-01" : "px-[24px] dark:bg-block-color dark:border-white/10 border-white border-[1px]", "  rounded-[12px] cursor-pointer flex items-center h-[54px] bg-white dark:bg-white/10"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item === null || item === void 0 ? void 0 : item.icon,
                                        className: "w-[32px] h-[32px] rounded-[8px] mr-[10px] object-cover border border-black/10 dark:border-white/10"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(item.method === "gamota_la" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_amount) > (userInfo === null || userInfo === void 0 ? void 0 : userInfo.total_la) && "opacity-60"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[14px] Nunito-700 leading-[14px] ".concat(item.method === "gamota_la" && "text-[#E8A236]"),
                                                children: item === null || item === void 0 ? void 0 : item.name
                                            }),
                                            item.method === "gamota_la" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[#E8A236] text-[12px] Nunito-500",
                                                children: t("store.la_number", {
                                                    number: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_total_la = userInfo.total_la) === null || _userInfo_total_la === void 0 ? void 0 : _userInfo_total_la.toLocaleString()
                                                })
                                            })
                                        ]
                                    }),
                                    item.method === "gamota_la" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.v3_amount) > (userInfo === null || userInfo === void 0 ? void 0 : userInfo.total_la) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                        variant: "main",
                                        className: "h-[24px] ml-auto text-[12px] Nunito-SemoBold opacity-160",
                                        onClick: ()=>{
                                            router.push("/topup/napla");
                                        },
                                        children: t("store.la_invoice")
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative ml-auto group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mr-0 text-sm text-right Nunito-700",
                                                children: [
                                                    "đ ",
                                                    item === null || item === void 0 ? void 0 : (_item_item = item.item) === null || _item_item === void 0 ? void 0 : (_item_item_amount = _item_item.amount) === null || _item_item_amount === void 0 ? void 0 : _item_item_amount.toLocaleString()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mr-0 text-xs text-right text-main-01 Nunito-600",
                                                children: [
                                                    item === null || item === void 0 ? void 0 : (_item_item1 = item.item) === null || _item_item1 === void 0 ? void 0 : _item_item1.value,
                                                    " ",
                                                    item === null || item === void 0 ? void 0 : (_item_item2 = item.item) === null || _item_item2 === void 0 ? void 0 : _item_item2.currency
                                                ]
                                            }),
                                            !!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.hoverDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute bottom-6 z-10 scale-0 min-w-[300px] max-w-[300px] rounded-2xl Nunito-500 bg-white p-4 transition-all text-sm text-main-text-color border border-input-border-light group-hover:scale-100",
                                                children: selectedData === null || selectedData === void 0 ? void 0 : selectedData.hoverDescription
                                            })
                                        ]
                                    })
                                ]
                            }, "".concat(item === null || item === void 0 ? void 0 : item.method, "-").concat(item === null || item === void 0 ? void 0 : (_item_item3 = item.item) === null || _item_item3 === void 0 ? void 0 : _item_item3.package_id, "-").concat(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage2 = selectedData.selectPackage) === null || _selectedData_selectPackage2 === void 0 ? void 0 : _selectedData_selectPackage2.v3_id));
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/configs/index.ts + 3 modules
var configs = __webpack_require__(54254);
// EXTERNAL MODULE: ./app/components/icon-tsx/IconVoucherBold.tsx
var IconVoucherBold = __webpack_require__(50454);
;// CONCATENATED MODULE: ./app/containers/topup/detail/voucher/VoucherComponent.tsx






const VoucherComponent = (param)=>{
    let { setErrorCode , errorCode , selectedData , setSelectedData , checkVoucher , loading , applyVoucher , total , setApplyVoucher  } = param;
    var _applyVoucher_voucher, _applyVoucher_voucher1;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const [value, setValue] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (selectedData === null || selectedData === void 0 ? void 0 : selectedData.voucher_code) {
            setValue((selectedData === null || selectedData === void 0 ? void 0 : selectedData.voucher_code) || "");
            setErrorCode("");
        }
    }, [
        selectedData === null || selectedData === void 0 ? void 0 : selectedData.voucher_code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-[16px] border border-dashed border-neutral-07/10 border-[0.4px] dark:border-white/10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "rounded-[8px] flex overflow-hidden h-[36px] mt-[24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 border border-r-0 dark:bg-white/10 border-black/10 rounded-tl-[8px] rounded-bl-[8px] py-[8px] px-[16px] flex gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "flex-1 h-full outline-0 bg-transparent border-0 text-[14px]",
                                value: value,
                                onChange: (e)=>{
                                    setValue(e.target.value);
                                    setErrorCode("");
                                },
                                placeholder: t("store.voucher_placeholder")
                            }),
                            value && /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                onClick: ()=>{
                                    setValue("");
                                    setErrorCode("");
                                    setSelectedData({
                                        ...selectedData,
                                        voucher_code: ""
                                    });
                                    setApplyVoucher(null);
                                },
                                className: "cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "8",
                                        cy: "8",
                                        r: "7",
                                        fill: themeApp === "dark" ? "#FFFFFF1A" : "black"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M11.3 5.64286L10.3573 4.7002L7.99995 7.05753L5.64262 4.7002L4.69995 5.64286L7.05728 8.0002L4.69995 10.3575L5.64262 11.3002L7.99995 8.94286L10.3573 11.3002L11.3 10.3575L8.94262 8.0002L11.3 5.64286Z",
                                        fill: "white"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[80px] text-[14px] Nunito-500 items-center flex justify-center bg-button dark:bg-white/20 border rounded-tr-[8px] rounded-br-[8px] border-black/10 ".concat(value.trim() ? "text-main-01 cursor-pointer" : "text-main-disable opacita-80"),
                        onClick: ()=>checkVoucher(value.trim()),
                        children: !loading ? t("store.apply") : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "Nunito-400 text-[#EB5757] text-[14px]",
                children: errorCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between mt-[12px] md:px-[16px] gap-3",
                children: [
                    (applyVoucher === null || applyVoucher === void 0 ? void 0 : (_applyVoucher_voucher = applyVoucher.voucher) === null || _applyVoucher_voucher === void 0 ? void 0 : _applyVoucher_voucher.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-2 flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconVoucherBold/* IconVoucherBold */.t, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] text-neutral-06 dark:text-neutral-07 flex-1 line-clamp-1",
                                children: applyVoucher === null || applyVoucher === void 0 ? void 0 : (_applyVoucher_voucher1 = applyVoucher.voucher) === null || _applyVoucher_voucher1 === void 0 ? void 0 : _applyVoucher_voucher1.name
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[14px] text-neutral-06 dark:text-neutral-07",
                        children: [
                            t("store.voucher_title"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[16px] Nunito-600",
                        children: [
                            "-",
                            (applyVoucher === null || applyVoucher === void 0 ? void 0 : applyVoucher.pay_amount) ? "đ ".concat((total - applyVoucher.pay_amount).toLocaleString()) : " 0 đ"
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/topup/detail/TopupOrderInfo.tsx












const TopupOrderInfo = (param)=>{
    let { selectedData , loadingCallingMethod , setVisible , setSelectedData , setErrorCode , errorCode , applyVoucher , loadingVoucher , checkVoucher , setApplyVoucher  } = param;
    var _selectedData_selectMethod, _selectedData_selectMethod_item, _selectedData_selectPackage, _selectedData_selectPackage1, _router_query, _selectedData_selectMethod1, _selectedData_selectMethod_item1, _selectedData_selectPackage2, _selectedData_selectPackage_package_amount, _selectedData_selectPackage3, _selectedData_selectMethod2, _selectedData_selectMethod3, _selectedData_selectMethod4, _selectedData_selectMethod5, _selectedData_selectMethod_item2, _selectedData_selectPackage4, _selectedData_selectPackage_package_amount1, _selectedData_selectPackage5;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { userInfo: userProfile , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const [checked, setChecked] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Store_TopupGame");
    const handleSubmitTopup = async ()=>{
        if (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id) {
            var _selectedData_selectMethod, _selectedData_selectMethod_item;
            setLoading(true);
            GAEventsTracker("Store_Bt_Buy", "Thanh toan nap game", selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount);
            try {
                if (!!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) && (selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) !== "VN") {
                    var _router_query, _selectedData_selectUser, _selectedData_selectServer, _selectedData_selectRole, _selectedData_selectPlatform, _res_data;
                    let body = {
                        slug_name: String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name),
                        package_id: selectedData === null || selectedData === void 0 ? void 0 : selectedData.selectPackage.package_id,
                        user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id,
                        server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id,
                        role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole = selectedData.selectRole) === null || _selectedData_selectRole === void 0 ? void 0 : _selectedData_selectRole.role_id,
                        country_code: selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code
                    };
                    if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform = selectedData.selectPlatform) === null || _selectedData_selectPlatform === void 0 ? void 0 : _selectedData_selectPlatform.platform_id) {
                        var _selectedData_selectPlatform1;
                        body = {
                            ...body,
                            platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform1 = selectedData.selectPlatform) === null || _selectedData_selectPlatform1 === void 0 ? void 0 : _selectedData_selectPlatform1.platform_id
                        };
                    }
                    const res = await TopupService/* default.submitDoTopupGlobal */.Z.submitDoTopupGlobal(body);
                    if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                        var _res_data1, _res_data_data;
                        router === null || router === void 0 ? void 0 : router.push(res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : (_res_data_data = _res_data1.data) === null || _res_data_data === void 0 ? void 0 : _res_data_data.url);
                    } else if ((res === null || res === void 0 ? void 0 : res.data.errorCode) === 15) {
                        setVisible(true);
                    } else {
                        var _res_data2;
                        toast({
                            title: res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : _res_data2.message,
                            variant: "error"
                        });
                    }
                } else {
                    var _selectedData_selectMethod1;
                    if ((selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod1 = selectedData.selectMethod) === null || _selectedData_selectMethod1 === void 0 ? void 0 : _selectedData_selectMethod1.method) === "appota_card") {
                        var _selectedData_selectMethod2, _selectedData_selectMethod3, _selectedData_selectMethod_item1, _selectedData_selectPackage, _selectedData_selectPackage1, _selectedData_selectMethod4, _selectedData_selectMethod_item2, _selectedData_selectUser1, _selectedData_selectServer1, _selectedData_selectServer2, _selectedData_selectRole1, _selectedData_selectRole2, _selectedData_selectPlatform2, _selectedData_selectPlatform3, _router_query1;
                        const query = {
                            method: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod2 = selectedData.selectMethod) === null || _selectedData_selectMethod2 === void 0 ? void 0 : _selectedData_selectMethod2.method,
                            amount: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod3 = selectedData.selectMethod) === null || _selectedData_selectMethod3 === void 0 ? void 0 : (_selectedData_selectMethod_item1 = _selectedData_selectMethod3.item) === null || _selectedData_selectMethod_item1 === void 0 ? void 0 : _selectedData_selectMethod_item1.amount,
                            v3_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id,
                            v3_title: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.v3_title,
                            package_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod4 = selectedData.selectMethod) === null || _selectedData_selectMethod4 === void 0 ? void 0 : (_selectedData_selectMethod_item2 = _selectedData_selectMethod4.item) === null || _selectedData_selectMethod_item2 === void 0 ? void 0 : _selectedData_selectMethod_item2.package_id,
                            user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser1 = selectedData.selectUser) === null || _selectedData_selectUser1 === void 0 ? void 0 : _selectedData_selectUser1.user_id,
                            server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer1 = selectedData.selectServer) === null || _selectedData_selectServer1 === void 0 ? void 0 : _selectedData_selectServer1.server_id,
                            server_name: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer2 = selectedData.selectServer) === null || _selectedData_selectServer2 === void 0 ? void 0 : _selectedData_selectServer2.server_name,
                            role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole1 = selectedData.selectRole) === null || _selectedData_selectRole1 === void 0 ? void 0 : _selectedData_selectRole1.role_id,
                            role_name: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole2 = selectedData.selectRole) === null || _selectedData_selectRole2 === void 0 ? void 0 : _selectedData_selectRole2.role_name,
                            platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform2 = selectedData.selectPlatform) === null || _selectedData_selectPlatform2 === void 0 ? void 0 : _selectedData_selectPlatform2.platform_id,
                            platform_name: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform3 = selectedData.selectPlatform) === null || _selectedData_selectPlatform3 === void 0 ? void 0 : _selectedData_selectPlatform3.platform_name
                        };
                        router.push({
                            pathname: "/topup/[slug_name]/input-card",
                            query: {
                                slug_name: router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.slug_name,
                                ...query
                            }
                        });
                    } else {
                        var _router_query2, _selectedData_selectMethod5, _selectedData_selectPackage2, _selectedData_selectMethod6, _selectedData_selectMethod_item3, _selectedData_selectUser2, _selectedData_selectServer3, _selectedData_selectRole3, _selectedData_selectPlatform4, _res_data3;
                        let body1 = {
                            slug_name: String(router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.slug_name),
                            method: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod5 = selectedData.selectMethod) === null || _selectedData_selectMethod5 === void 0 ? void 0 : _selectedData_selectMethod5.method,
                            v3_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage2 = selectedData.selectPackage) === null || _selectedData_selectPackage2 === void 0 ? void 0 : _selectedData_selectPackage2.v3_id,
                            package_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod6 = selectedData.selectMethod) === null || _selectedData_selectMethod6 === void 0 ? void 0 : (_selectedData_selectMethod_item3 = _selectedData_selectMethod6.item) === null || _selectedData_selectMethod_item3 === void 0 ? void 0 : _selectedData_selectMethod_item3.package_id,
                            user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser2 = selectedData.selectUser) === null || _selectedData_selectUser2 === void 0 ? void 0 : _selectedData_selectUser2.user_id,
                            server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer3 = selectedData.selectServer) === null || _selectedData_selectServer3 === void 0 ? void 0 : _selectedData_selectServer3.server_id,
                            role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole3 = selectedData.selectRole) === null || _selectedData_selectRole3 === void 0 ? void 0 : _selectedData_selectRole3.role_id,
                            voucher_code: selectedData === null || selectedData === void 0 ? void 0 : selectedData.voucher_code
                        };
                        if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform4 = selectedData.selectPlatform) === null || _selectedData_selectPlatform4 === void 0 ? void 0 : _selectedData_selectPlatform4.platform_id) {
                            var _selectedData_selectPlatform5;
                            body1 = {
                                ...body1,
                                platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform5 = selectedData.selectPlatform) === null || _selectedData_selectPlatform5 === void 0 ? void 0 : _selectedData_selectPlatform5.platform_id
                            };
                        }
                        const res1 = await TopupService/* default.submitDoTopup */.Z.submitDoTopup(body1);
                        if ((res1 === null || res1 === void 0 ? void 0 : (_res_data3 = res1.data) === null || _res_data3 === void 0 ? void 0 : _res_data3.errorCode) === 0) {
                            var _res_data4, _res_data_data1;
                            if (res1 === null || res1 === void 0 ? void 0 : (_res_data4 = res1.data) === null || _res_data4 === void 0 ? void 0 : (_res_data_data1 = _res_data4.data) === null || _res_data_data1 === void 0 ? void 0 : _res_data_data1.url.includes("la-invoice")) {
                                var _res_data5, _res_data_data2;
                                const _url = res1 === null || res1 === void 0 ? void 0 : (_res_data5 = res1.data) === null || _res_data5 === void 0 ? void 0 : (_res_data_data2 = _res_data5.data) === null || _res_data_data2 === void 0 ? void 0 : _res_data_data2.url.split("?transaction_id=");
                                router === null || router === void 0 ? void 0 : router.push(_url.join("/"));
                            } else {
                                var _res_data6, _res_data_data3;
                                router === null || router === void 0 ? void 0 : router.push(res1 === null || res1 === void 0 ? void 0 : (_res_data6 = res1.data) === null || _res_data6 === void 0 ? void 0 : (_res_data_data3 = _res_data6.data) === null || _res_data_data3 === void 0 ? void 0 : _res_data_data3.url);
                            }
                        } else if ((res1 === null || res1 === void 0 ? void 0 : res1.data.errorCode) === 15) {
                            setVisible(true);
                        } else {
                            var _res_data7;
                            toast({
                                title: res1 === null || res1 === void 0 ? void 0 : (_res_data7 = res1.data) === null || _res_data7 === void 0 ? void 0 : _res_data7.message,
                                variant: "error"
                            });
                        }
                    }
                }
            } catch (err) {
                if (err.data.errorCode === 15) {
                    setVisible(true);
                } else {
                    var _err_data;
                    toast({
                        title: err === null || err === void 0 ? void 0 : (_err_data = err.data) === null || _err_data === void 0 ? void 0 : _err_data.message,
                        variant: "error"
                    });
                }
            } finally{
                setLoading(false);
            }
        } else {
            setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL);
        }
    };
    const disableBtn = ()=>{
        var _selectedData_selectPackage, _selectedData_selectPackage1;
        if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id) {
            var _selectedData_selectMethod, _selectedData_selectMethod_item, _selectedData_selectPackage2, _selectedData_selectRole, _selectedData_selectUser;
            return !userProfile || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage2 = selectedData.selectPackage) === null || _selectedData_selectPackage2 === void 0 ? void 0 : _selectedData_selectPackage2.v3_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole = selectedData.selectRole) === null || _selectedData_selectRole === void 0 ? void 0 : _selectedData_selectRole.role_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id) || loadingCallingMethod || !checked;
        }
        if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.package_id) {
            var _selectedData_selectPackage3, _selectedData_selectRole1, _selectedData_selectUser1;
            return !userProfile || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage3 = selectedData.selectPackage) === null || _selectedData_selectPackage3 === void 0 ? void 0 : _selectedData_selectPackage3.package_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole1 = selectedData.selectRole) === null || _selectedData_selectRole1 === void 0 ? void 0 : _selectedData_selectRole1.role_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser1 = selectedData.selectUser) === null || _selectedData_selectUser1 === void 0 ? void 0 : _selectedData_selectUser1.user_id) || !(selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) || !checked;
        }
        return true;
    };
    const totalNumber = (applyVoucher === null || applyVoucher === void 0 ? void 0 : applyVoucher.pay_amount) ? applyVoucher === null || applyVoucher === void 0 ? void 0 : applyVoucher.pay_amount : selectedData.selectPackage.v3_id ? selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[16px] Nunito-700 pb-[16px]",
                children: t("store.order_infor")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "rounded-[16px] bg-white px-[16px] py-[24px] dark:bg-white/10 border border-[0.4px] dark:border-white/10 mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[16px] Nunito-700 px-[12px] py-[4px]",
                        children: (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_title) || (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.package_title) || "--"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-[16px] border border-dashed border-neutral-07/10 border-[0.4px] dark:border-white/10"
                    }),
                    ((_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name) === "napla" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-[12px] grid grid-cols-2 gap-[12px] pb-[6px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "text-[14px] text-neutral-06 dark:text-neutral-07",
                                children: [
                                    t("store.la_accouct"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[16px] Nunito-600 text-end",
                                children: userProfile === null || userProfile === void 0 ? void 0 : userProfile.username
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-[12px] grid grid-cols-2 gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "text-[14px] text-neutral-06 dark:text-neutral-07",
                                children: [
                                    t("store.total_amount"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[16px] Nunito-600 text-end",
                                children: [
                                    selectedData.selectPackage.v3_id && "".concat(((selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod1 = selectedData.selectMethod) === null || _selectedData_selectMethod1 === void 0 ? void 0 : (_selectedData_selectMethod_item1 = _selectedData_selectMethod1.item) === null || _selectedData_selectMethod_item1 === void 0 ? void 0 : _selectedData_selectMethod_item1.amount) || 0).toLocaleString(), " đ"),
                                    selectedData.selectPackage.package_id && "".concat((_selectedData_selectPackage2 = selectedData.selectPackage) === null || _selectedData_selectPackage2 === void 0 ? void 0 : (_selectedData_selectPackage_package_amount = _selectedData_selectPackage2.package_amount) === null || _selectedData_selectPackage_package_amount === void 0 ? void 0 : _selectedData_selectPackage_package_amount.toLocaleString(), " ").concat((_selectedData_selectPackage3 = selectedData.selectPackage) === null || _selectedData_selectPackage3 === void 0 ? void 0 : _selectedData_selectPackage3.currency)
                                ]
                            })
                        ]
                    }),
                    (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod2 = selectedData.selectMethod) === null || _selectedData_selectMethod2 === void 0 ? void 0 : _selectedData_selectMethod2.method) !== "appota_card" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod3 = selectedData.selectMethod) === null || _selectedData_selectMethod3 === void 0 ? void 0 : _selectedData_selectMethod3.method) !== "va_bank_atm" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod4 = selectedData.selectMethod) === null || _selectedData_selectMethod4 === void 0 ? void 0 : _selectedData_selectMethod4.method) !== "bank_qrpay" && !(!!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) && (selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) !== "VN") && /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherComponent, {
                        setErrorCode: setErrorCode,
                        errorCode: errorCode,
                        selectedData: selectedData,
                        setSelectedData: setSelectedData,
                        checkVoucher: checkVoucher,
                        loading: loadingVoucher,
                        applyVoucher: applyVoucher,
                        total: selectedData.selectPackage.v3_id ? selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod5 = selectedData.selectMethod) === null || _selectedData_selectMethod5 === void 0 ? void 0 : (_selectedData_selectMethod_item2 = _selectedData_selectMethod5.item) === null || _selectedData_selectMethod_item2 === void 0 ? void 0 : _selectedData_selectMethod_item2.amount : 0,
                        setApplyVoucher: setApplyVoucher
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-[16px] border border-dashed border-neutral-07/10 border-[0.4px] dark:border-white/10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between mb-[16px] px-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "text-[16px] Nunito-500 text-neutral-03 dark:text-neutral-07",
                                children: t("store.total")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[18px] text-main-01 dark:text-main-red-02 Nunito-700",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "Nunito-700",
                                        children: [
                                            selectedData.selectPackage.v3_id && (totalNumber === null || totalNumber === void 0 ? void 0 : totalNumber.toLocaleString()),
                                            selectedData.selectPackage.package_id && ((_selectedData_selectPackage4 = selectedData.selectPackage) === null || _selectedData_selectPackage4 === void 0 ? void 0 : (_selectedData_selectPackage_package_amount1 = _selectedData_selectPackage4.package_amount) === null || _selectedData_selectPackage_package_amount1 === void 0 ? void 0 : _selectedData_selectPackage_package_amount1.toLocaleString())
                                        ]
                                    }),
                                    " ",
                                    selectedData.selectPackage.v3_id && "đ",
                                    selectedData.selectPackage.package_id && ((_selectedData_selectPackage5 = selectedData.selectPackage) === null || _selectedData_selectPackage5 === void 0 ? void 0 : _selectedData_selectPackage5.currency)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "Nunito-400 px-[16px] text-[12px] text-[#A0A2A3] pb-3 flex items-start cursor-pointer",
                        onClick: ()=>setChecked(!checked),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-[10px] mt-1",
                                children: checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 14 14",
                                    fill: "none",
                                    className: "w-[16px] h-[16px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M10.5003 1.1665H3.50033C2.21166 1.1665 1.16699 2.21117 1.16699 3.49984V10.4998C1.16699 11.7885 2.21166 12.8332 3.50033 12.8332H10.5003C11.789 12.8332 12.8337 11.7885 12.8337 10.4998V3.49984C12.8337 2.21117 11.789 1.1665 10.5003 1.1665ZM9.679 5.51846C9.82735 5.32773 9.79299 5.05286 9.60226 4.90452C9.41153 4.75617 9.13666 4.79053 8.98832 4.98126L6.6509 7.98651C6.59893 8.05334 6.50116 8.06201 6.43823 8.00537L4.95967 6.67467C4.78007 6.51303 4.50344 6.52759 4.3418 6.70719C4.18017 6.88678 4.19473 7.16341 4.37432 7.32505L5.85289 8.65576C6.29338 9.0522 6.97775 8.99149 7.34159 8.52371L9.679 5.51846Z",
                                        fill: "#3263E4"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[16px] h-[16px] border border-neutral-07 rounded-[4px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                    i18nKey: t("common.agree_to_privacy_policy_02"),
                                    className: "flex",
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                window.open("/term-of-services");
                                            },
                                            className: "text-[#403D53] dark:text-white underline cursor-pointer ml-[1px] Nunito-700"
                                        }, 0),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                window.open("/privacy-policy");
                                            },
                                            className: "text-[#403D53] dark:text-white underline cursor-pointer ml-[1px] Nunito-700"
                                        }, 1)
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                        loading: loading,
                        variant: "main",
                        disabled: disableBtn(),
                        onClick: handleSubmitTopup,
                        className: "w-full",
                        children: !loading ? t("store.buy_now") : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {})
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/topup/detail/TopupOrderInfoMobile.tsx












const TopupOrderInfoMobile = (param)=>{
    let { selectedData , setSelectedData , loadingCallingMethod , renderMethods , setVisible , setErrorCode , errorCode , applyVoucher , loadingVoucher , checkVoucher , setApplyVoucher  } = param;
    var _selectedData_selectMethod, _selectedData_selectMethod_item;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const { userInfo: userProfile , themeApp , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const [checked, setChecked] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [show, setShow] = (0,react.useState)(false);
    const GAEventsTracker = (0,useGAEventsTracker/* default */.Z)("Store_TopupGame");
    const handleSubmitTopup = async ()=>{
        if (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id) {
            var _selectedData_selectMethod, _selectedData_selectMethod_item;
            setLoading(true);
            GAEventsTracker("Store_Bt_Buy", "Thanh toan nap game", selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount);
            try {
                if (!!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) && (selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) !== "VN") {
                    var _router_query, _selectedData_selectUser, _selectedData_selectServer, _selectedData_selectRole, _selectedData_selectPlatform, _res_data;
                    let body = {
                        slug_name: String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name),
                        package_id: selectedData === null || selectedData === void 0 ? void 0 : selectedData.selectPackage.package_id,
                        user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id,
                        server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id,
                        role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole = selectedData.selectRole) === null || _selectedData_selectRole === void 0 ? void 0 : _selectedData_selectRole.role_id,
                        country_code: selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code
                    };
                    if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform = selectedData.selectPlatform) === null || _selectedData_selectPlatform === void 0 ? void 0 : _selectedData_selectPlatform.platform_id) {
                        var _selectedData_selectPlatform1;
                        body = {
                            ...body,
                            platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform1 = selectedData.selectPlatform) === null || _selectedData_selectPlatform1 === void 0 ? void 0 : _selectedData_selectPlatform1.platform_id
                        };
                    }
                    const res = await TopupService/* default.submitDoTopupGlobal */.Z.submitDoTopupGlobal(body);
                    if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                        var _res_data1, _res_data_data;
                        router === null || router === void 0 ? void 0 : router.push(res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : (_res_data_data = _res_data1.data) === null || _res_data_data === void 0 ? void 0 : _res_data_data.url);
                    } else if ((res === null || res === void 0 ? void 0 : res.data.errorCode) === 15) {
                        setVisible(true);
                    } else {
                        var _res_data2;
                        toast({
                            title: res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : _res_data2.message,
                            variant: "error"
                        });
                    }
                } else {
                    var _selectedData_selectMethod1;
                    if ((selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod1 = selectedData.selectMethod) === null || _selectedData_selectMethod1 === void 0 ? void 0 : _selectedData_selectMethod1.method) === "appota_card") {
                        var _selectedData_selectMethod2, _selectedData_selectMethod3, _selectedData_selectMethod_item1, _selectedData_selectPackage, _selectedData_selectPackage1, _selectedData_selectMethod4, _selectedData_selectMethod_item2, _selectedData_selectUser1, _selectedData_selectServer1, _selectedData_selectServer2, _selectedData_selectRole1, _selectedData_selectRole2, _selectedData_selectPlatform2, _selectedData_selectPlatform3, _router_query1;
                        const query = {
                            method: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod2 = selectedData.selectMethod) === null || _selectedData_selectMethod2 === void 0 ? void 0 : _selectedData_selectMethod2.method,
                            amount: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod3 = selectedData.selectMethod) === null || _selectedData_selectMethod3 === void 0 ? void 0 : (_selectedData_selectMethod_item1 = _selectedData_selectMethod3.item) === null || _selectedData_selectMethod_item1 === void 0 ? void 0 : _selectedData_selectMethod_item1.amount,
                            v3_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id,
                            v3_title: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.v3_title,
                            package_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod4 = selectedData.selectMethod) === null || _selectedData_selectMethod4 === void 0 ? void 0 : (_selectedData_selectMethod_item2 = _selectedData_selectMethod4.item) === null || _selectedData_selectMethod_item2 === void 0 ? void 0 : _selectedData_selectMethod_item2.package_id,
                            user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser1 = selectedData.selectUser) === null || _selectedData_selectUser1 === void 0 ? void 0 : _selectedData_selectUser1.user_id,
                            server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer1 = selectedData.selectServer) === null || _selectedData_selectServer1 === void 0 ? void 0 : _selectedData_selectServer1.server_id,
                            server_name: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer2 = selectedData.selectServer) === null || _selectedData_selectServer2 === void 0 ? void 0 : _selectedData_selectServer2.server_name,
                            role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole1 = selectedData.selectRole) === null || _selectedData_selectRole1 === void 0 ? void 0 : _selectedData_selectRole1.role_id,
                            role_name: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole2 = selectedData.selectRole) === null || _selectedData_selectRole2 === void 0 ? void 0 : _selectedData_selectRole2.role_name,
                            platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform2 = selectedData.selectPlatform) === null || _selectedData_selectPlatform2 === void 0 ? void 0 : _selectedData_selectPlatform2.platform_id,
                            platform_name: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform3 = selectedData.selectPlatform) === null || _selectedData_selectPlatform3 === void 0 ? void 0 : _selectedData_selectPlatform3.platform_name
                        };
                        router.push({
                            pathname: "/topup/[slug_name]/input-card",
                            query: {
                                slug_name: router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.slug_name,
                                ...query
                            }
                        });
                    } else {
                        var _router_query2, _selectedData_selectMethod5, _selectedData_selectPackage2, _selectedData_selectMethod6, _selectedData_selectMethod_item3, _selectedData_selectUser2, _selectedData_selectServer3, _selectedData_selectRole3, _selectedData_selectPlatform4, _res_data3;
                        let body1 = {
                            slug_name: String(router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.slug_name),
                            method: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod5 = selectedData.selectMethod) === null || _selectedData_selectMethod5 === void 0 ? void 0 : _selectedData_selectMethod5.method,
                            v3_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage2 = selectedData.selectPackage) === null || _selectedData_selectPackage2 === void 0 ? void 0 : _selectedData_selectPackage2.v3_id,
                            package_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod6 = selectedData.selectMethod) === null || _selectedData_selectMethod6 === void 0 ? void 0 : (_selectedData_selectMethod_item3 = _selectedData_selectMethod6.item) === null || _selectedData_selectMethod_item3 === void 0 ? void 0 : _selectedData_selectMethod_item3.package_id,
                            user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser2 = selectedData.selectUser) === null || _selectedData_selectUser2 === void 0 ? void 0 : _selectedData_selectUser2.user_id,
                            server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer3 = selectedData.selectServer) === null || _selectedData_selectServer3 === void 0 ? void 0 : _selectedData_selectServer3.server_id,
                            role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole3 = selectedData.selectRole) === null || _selectedData_selectRole3 === void 0 ? void 0 : _selectedData_selectRole3.role_id,
                            voucher_code: selectedData === null || selectedData === void 0 ? void 0 : selectedData.voucher_code
                        };
                        if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform4 = selectedData.selectPlatform) === null || _selectedData_selectPlatform4 === void 0 ? void 0 : _selectedData_selectPlatform4.platform_id) {
                            var _selectedData_selectPlatform5;
                            body1 = {
                                ...body1,
                                platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform5 = selectedData.selectPlatform) === null || _selectedData_selectPlatform5 === void 0 ? void 0 : _selectedData_selectPlatform5.platform_id
                            };
                        }
                        const res1 = await TopupService/* default.submitDoTopup */.Z.submitDoTopup(body1);
                        if ((res1 === null || res1 === void 0 ? void 0 : (_res_data3 = res1.data) === null || _res_data3 === void 0 ? void 0 : _res_data3.errorCode) === 0) {
                            var _res_data4, _res_data_data1;
                            if (res1 === null || res1 === void 0 ? void 0 : (_res_data4 = res1.data) === null || _res_data4 === void 0 ? void 0 : (_res_data_data1 = _res_data4.data) === null || _res_data_data1 === void 0 ? void 0 : _res_data_data1.url.includes("la-invoice")) {
                                var _res_data5, _res_data_data2;
                                const _url = res1 === null || res1 === void 0 ? void 0 : (_res_data5 = res1.data) === null || _res_data5 === void 0 ? void 0 : (_res_data_data2 = _res_data5.data) === null || _res_data_data2 === void 0 ? void 0 : _res_data_data2.url.split("?transaction_id=");
                                router === null || router === void 0 ? void 0 : router.push(_url.join("/"));
                            } else {
                                var _res_data6, _res_data_data3;
                                router === null || router === void 0 ? void 0 : router.push(res1 === null || res1 === void 0 ? void 0 : (_res_data6 = res1.data) === null || _res_data6 === void 0 ? void 0 : (_res_data_data3 = _res_data6.data) === null || _res_data_data3 === void 0 ? void 0 : _res_data_data3.url);
                            }
                        } else if ((res1 === null || res1 === void 0 ? void 0 : res1.data.errorCode) === 15) {
                            setVisible(true);
                        } else {
                            var _res_data7;
                            toast({
                                title: res1 === null || res1 === void 0 ? void 0 : (_res_data7 = res1.data) === null || _res_data7 === void 0 ? void 0 : _res_data7.message,
                                variant: "error"
                            });
                        }
                    }
                }
            } catch (err) {
                if (err.data.errorCode === 15) {
                    setVisible(true);
                } else {
                    var _err_data;
                    toast({
                        title: err === null || err === void 0 ? void 0 : (_err_data = err.data) === null || _err_data === void 0 ? void 0 : _err_data.message,
                        variant: "error"
                    });
                }
            } finally{
                setLoading(false);
            }
        } else {
            setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL);
        }
    };
    const disableBtn = ()=>{
        var _selectedData_selectPackage, _selectedData_selectPackage1;
        if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id) {
            var _selectedData_selectMethod, _selectedData_selectMethod_item, _selectedData_selectPackage2, _selectedData_selectRole, _selectedData_selectUser;
            return !userProfile || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage2 = selectedData.selectPackage) === null || _selectedData_selectPackage2 === void 0 ? void 0 : _selectedData_selectPackage2.v3_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole = selectedData.selectRole) === null || _selectedData_selectRole === void 0 ? void 0 : _selectedData_selectRole.role_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id) || loadingCallingMethod || show && !checked;
        }
        if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.package_id) {
            var _selectedData_selectPackage3, _selectedData_selectRole1, _selectedData_selectUser1;
            return !userProfile || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage3 = selectedData.selectPackage) === null || _selectedData_selectPackage3 === void 0 ? void 0 : _selectedData_selectPackage3.package_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole1 = selectedData.selectRole) === null || _selectedData_selectRole1 === void 0 ? void 0 : _selectedData_selectRole1.role_id) || !(selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser1 = selectedData.selectUser) === null || _selectedData_selectUser1 === void 0 ? void 0 : _selectedData_selectUser1.user_id) || !(selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) || show && !checked;
        }
        return true;
    };
    const onChangeSelectMethod = (item)=>{
        if (!loading) {
            // GAEventsTracker("Store_Topup_package")
            if (item.method !== "gamota_la" || selectedData.selectPackage.v3_amount <= userProfile.total_la) setSelectedData({
                ...selectedData,
                selectMethod: item
            });
        }
    };
    const totalNumber = (applyVoucher === null || applyVoucher === void 0 ? void 0 : applyVoucher.pay_amount) ? applyVoucher === null || applyVoucher === void 0 ? void 0 : applyVoucher.pay_amount : selectedData.selectPackage.v3_id ? selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount : 0;
    const renderCheckoutDetail = ()=>{
        var _selectedData_selectPackage, _selectedData_selectPackage1, _selectedData_selectMethod, _selectedData_selectMethod_item, _selectedData_selectPackage2, _selectedData_selectPackage_package_amount, _selectedData_selectPackage3, _selectedData_selectMethod1, _selectedData_selectMethod_item1, _selectedData_selectPackage4, _selectedData_selectPackage_package_amount1, _selectedData_selectPackage5, _selectedData_selectMethod2, _selectedData_selectMethod3, _selectedData_selectMethod4, _selectedData_selectMethod5, _selectedData_selectMethod_item2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col h-full hidden-scroll-bar",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center w-full gap-2 px-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setShow(false);
                                },
                                className: "bg-bg-button dark:bg-white/10 rounded-[8px] p-[4px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "21",
                                    height: "21",
                                    viewBox: "0 0 21 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M13.125 17.4301L7.41997 11.7251C6.74622 11.0513 6.74622 9.94882 7.41997 9.27507L13.125 3.57007",
                                        stroke: themeApp === "dark" ? "#FFFFFF" : "#100D28",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "Nunito-700 text-[16px] dark:text-main-white flex-1 text-center",
                                children: t("store.pay")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col overflow-auto px-[16px]",
                        style: {
                            height: "calc(100dvh - 230px)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between gap-[8px] items-center my-[16px] rounded-[12px] p-[8px] pl-[16px] border border-main-01 text-[16px] Nunito-700",
                                children: [
                                    (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_title) || (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.package_title) || "--",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "bg-bg-02-text-box whitespace-nowrap dark:bg-white/10 px-[12px] py-[4px] rounded-[8px]",
                                        children: [
                                            selectedData.selectPackage.v3_id && "".concat(((selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount) || 0).toLocaleString(), " đ"),
                                            selectedData.selectPackage.package_id && "".concat((_selectedData_selectPackage2 = selectedData.selectPackage) === null || _selectedData_selectPackage2 === void 0 ? void 0 : (_selectedData_selectPackage_package_amount = _selectedData_selectPackage2.package_amount) === null || _selectedData_selectPackage_package_amount === void 0 ? void 0 : _selectedData_selectPackage_package_amount.toLocaleString(), " ").concat((_selectedData_selectPackage3 = selectedData.selectPackage) === null || _selectedData_selectPackage3 === void 0 ? void 0 : _selectedData_selectPackage3.currency)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-[12px] grid grid-cols-2 gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "text-[14px] text-neutral-06 dark:text-neutral-07",
                                        children: [
                                            t("store.total_amount"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-[16px] Nunito-600 text-end",
                                        children: [
                                            selectedData.selectPackage.v3_id && "".concat(((selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod1 = selectedData.selectMethod) === null || _selectedData_selectMethod1 === void 0 ? void 0 : (_selectedData_selectMethod_item1 = _selectedData_selectMethod1.item) === null || _selectedData_selectMethod_item1 === void 0 ? void 0 : _selectedData_selectMethod_item1.amount) || 0).toLocaleString(), " đ"),
                                            selectedData.selectPackage.package_id && "".concat((_selectedData_selectPackage4 = selectedData.selectPackage) === null || _selectedData_selectPackage4 === void 0 ? void 0 : (_selectedData_selectPackage_package_amount1 = _selectedData_selectPackage4.package_amount) === null || _selectedData_selectPackage_package_amount1 === void 0 ? void 0 : _selectedData_selectPackage_package_amount1.toLocaleString(), " ").concat((_selectedData_selectPackage5 = selectedData.selectPackage) === null || _selectedData_selectPackage5 === void 0 ? void 0 : _selectedData_selectPackage5.currency)
                                        ]
                                    })
                                ]
                            }),
                            (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod2 = selectedData.selectMethod) === null || _selectedData_selectMethod2 === void 0 ? void 0 : _selectedData_selectMethod2.method) !== "appota_card" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod3 = selectedData.selectMethod) === null || _selectedData_selectMethod3 === void 0 ? void 0 : _selectedData_selectMethod3.method) !== "va_bank_atm" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod4 = selectedData.selectMethod) === null || _selectedData_selectMethod4 === void 0 ? void 0 : _selectedData_selectMethod4.method) !== "bank_qrpay" && !(!!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) && (selectedData === null || selectedData === void 0 ? void 0 : selectedData.country_code) !== "VN") && /*#__PURE__*/ (0,jsx_runtime.jsx)(VoucherComponent, {
                                setErrorCode: setErrorCode,
                                errorCode: errorCode,
                                selectedData: selectedData,
                                setSelectedData: setSelectedData,
                                checkVoucher: checkVoucher,
                                loading: loadingVoucher,
                                applyVoucher: applyVoucher,
                                total: selectedData.selectPackage.v3_id ? selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod5 = selectedData.selectMethod) === null || _selectedData_selectMethod5 === void 0 ? void 0 : (_selectedData_selectMethod_item2 = _selectedData_selectMethod5.item) === null || _selectedData_selectMethod_item2 === void 0 ? void 0 : _selectedData_selectMethod_item2.amount : 0,
                                setApplyVoucher: setApplyVoucher
                            }),
                            selectedData.selectPackage.v3_id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-[24px] border border-dashed border-neutral-07/10 border-[0.4px] dark:border-white/10"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-[14px] Nunito-700 pb-[16px]",
                                                children: t("store.payment_method")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col gap-[16px] md:hidden",
                                                children: !!(renderMethods === null || renderMethods === void 0 ? void 0 : renderMethods.length) && renderMethods.map((item, index)=>{
                                                    var _selectedData_selectMethod, _selectedData_selectPackage, _userProfile_total_la, _selectedData_selectPackage1, _item_item, _item_item_amount, _item_item1, _item_item2;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: ()=>{
                                                            onChangeSelectMethod(item);
                                                        },
                                                        className: "".concat((item === null || item === void 0 ? void 0 : item.method) === (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : _selectedData_selectMethod.method) ? "border-[1px] px-[24px] border-main-01" : "px-[24px] dark:bg-block-color dark:border-white/10 border-white border-[1px]", "  rounded-[12px] flex items-center h-[54px] bg-white dark:bg-white/10 w-full"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: item === null || item === void 0 ? void 0 : item.icon,
                                                                className: "w-[32px] h-[32px] rounded-[8px] mr-[10px] object-cover border border-black/10 dark:border-white/10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat(item.method === "gamota_la" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_amount) > (userProfile === null || userProfile === void 0 ? void 0 : userProfile.total_la) && "opacity-60"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-[14px] Nunito-700 leading-[14px] ".concat(item.method === "gamota_la" && "text-[#E8A236]"),
                                                                        children: item === null || item === void 0 ? void 0 : item.name
                                                                    }),
                                                                    item.method === "gamota_la" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-[#E8A236] text-[12px] Nunito-500",
                                                                        children: t("store.la_number", {
                                                                            number: userProfile === null || userProfile === void 0 ? void 0 : (_userProfile_total_la = userProfile.total_la) === null || _userProfile_total_la === void 0 ? void 0 : _userProfile_total_la.toLocaleString()
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            item.method === "gamota_la" && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.v3_amount) > (userProfile === null || userProfile === void 0 ? void 0 : userProfile.total_la) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                                variant: "main",
                                                                className: "h-[24px] ml-auto text-[12px] Nunito-SemoBold opacity-160",
                                                                onClick: ()=>{
                                                                    router.push("/topup/napla");
                                                                },
                                                                children: t("store.la_invoice")
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "relative ml-auto group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        className: "mr-0 text-sm text-right text-main-01 Nunito-700",
                                                                        children: [
                                                                            "đ ",
                                                                            item === null || item === void 0 ? void 0 : (_item_item = item.item) === null || _item_item === void 0 ? void 0 : (_item_item_amount = _item_item.amount) === null || _item_item_amount === void 0 ? void 0 : _item_item_amount.toLocaleString()
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        className: "mr-0 text-xs text-right text-main-01 Nunito-600",
                                                                        children: [
                                                                            item === null || item === void 0 ? void 0 : (_item_item1 = item.item) === null || _item_item1 === void 0 ? void 0 : _item_item1.value,
                                                                            " ",
                                                                            item === null || item === void 0 ? void 0 : (_item_item2 = item.item) === null || _item_item2 === void 0 ? void 0 : _item_item2.currency
                                                                        ]
                                                                    }),
                                                                    !!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.hoverDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "absolute bottom-6 z-10 scale-0 min-w-[300px] max-w-[300px] rounded-2xl Nunito-500 bg-white p-4 transition-all text-sm text-main-text-color border border-input-border-light group-hover:scale-100",
                                                                        children: selectedData === null || selectedData === void 0 ? void 0 : selectedData.hoverDescription
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-auto bg-white dark:bg-bg-header rounded-tl-[16px] rounded-tr-[16px] absolute bottom-0 left-0 right-0 w-full px-[16px] py-[24px]",
                        style: {
                            boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.04)"
                        },
                        children: renderCheckout()
                    })
                ]
            })
        });
    };
    const renderCheckout = ()=>{
        var _selectedData_selectMethod, _selectedData_selectMethod_item, _selectedData_selectPackage, _selectedData_selectPackage_package_amount, _selectedData_selectPackage1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between mb-[8px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: "text-[14px] Nunito-700",
                            children: t("store.total")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] text-main-red-02",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "Nunito-700",
                                children: [
                                    selectedData.selectPackage.v3_id && (show ? totalNumber === null || totalNumber === void 0 ? void 0 : totalNumber.toLocaleString() : ((selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.amount) || 0).toLocaleString()),
                                    selectedData.selectPackage.package_id && ((_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : (_selectedData_selectPackage_package_amount = _selectedData_selectPackage.package_amount) === null || _selectedData_selectPackage_package_amount === void 0 ? void 0 : _selectedData_selectPackage_package_amount.toLocaleString()),
                                    " ",
                                    selectedData.selectPackage.v3_id && "đ",
                                    selectedData.selectPackage.package_id && ((_selectedData_selectPackage1 = selectedData.selectPackage) === null || _selectedData_selectPackage1 === void 0 ? void 0 : _selectedData_selectPackage1.currency)
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-auto mb-0",
                    children: [
                        show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "Nunito-400 text-[12px] pb-2 text-[#A0A2A3] flex items-start cursor-pointer",
                            onClick: ()=>setChecked(!checked),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr-[10px] mt-1",
                                    children: checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        className: "w-[16px] h-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M10.5003 1.1665H3.50033C2.21166 1.1665 1.16699 2.21117 1.16699 3.49984V10.4998C1.16699 11.7885 2.21166 12.8332 3.50033 12.8332H10.5003C11.789 12.8332 12.8337 11.7885 12.8337 10.4998V3.49984C12.8337 2.21117 11.789 1.1665 10.5003 1.1665ZM9.679 5.51846C9.82735 5.32773 9.79299 5.05286 9.60226 4.90452C9.41153 4.75617 9.13666 4.79053 8.98832 4.98126L6.6509 7.98651C6.59893 8.05334 6.50116 8.06201 6.43823 8.00537L4.95967 6.67467C4.78007 6.51303 4.50344 6.52759 4.3418 6.70719C4.18017 6.88678 4.19473 7.16341 4.37432 7.32505L5.85289 8.65576C6.29338 9.0522 6.97775 8.99149 7.34159 8.52371L9.679 5.51846Z",
                                            fill: "#3263E4"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[16px] h-[16px] border border-neutral-07 rounded-[4px]"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                        i18nKey: t("common.agree_to_privacy_policy_02"),
                                        className: "flex",
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    window.open("/term-of-services");
                                                },
                                                className: "text-[#403D53] dark:text-white underline cursor-pointer ml-[1px] Nunito-700"
                                            }, 0),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    window.open("/privacy-policy");
                                                },
                                                className: "text-[#403D53] dark:text-white underline cursor-pointer ml-[1px] Nunito-700"
                                            }, 1)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                            loading: loading,
                            variant: "main",
                            disabled: disableBtn(),
                            onClick: ()=>{
                                if (show) {
                                    handleSubmitTopup();
                                } else {
                                    setShow(true);
                                }
                            },
                            className: "w-full",
                            children: !loading ? t("store.pay") : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_btn/* LoadingBtnComponent */.n, {})
                        })
                    ]
                })
            ]
        });
    };
    (0,react.useEffect)(()=>{
        if (show) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "scroll";
        }
        return ()=>{
            document.body.style.overflow = "scroll";
        };
    }, [
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(show ? "bg-bg-light dark:bg-bg-02 h-full" : "bg-white dark:bg-bg-header px-[16px]", " py-[24px]  fixed bottom-0 left-0 right-0 w-full"),
        style: {
            boxShadow: "4px 4px 15px 0px rgba(0, 0, 0, 0.04)",
            zIndex: 50,
            height: show ? "100dvh" : ""
        },
        children: show ? renderCheckoutDetail() : renderCheckout()
    });
};

// EXTERNAL MODULE: ./app/containers/topup/detail/UpdatePhoneModal.tsx + 1 modules
var UpdatePhoneModal = __webpack_require__(76633);
;// CONCATENATED MODULE: ./app/containers/topup/detail/SecondStep.tsx









const SecondStep = (param)=>{
    let { packageAndTab , selectedTab , handleChangeSelectedTab , selectedData , setSelectedData , loading , setLoading , extendData , listPackageType , gameDetail  } = param;
    var _selectedData_selectMethod;
    const [renderMethods, setRenderMethods] = (0,react.useState)([]);
    const [visible, setVisible] = (0,react.useState)(false);
    const [errorCode, setErrorCode] = (0,react.useState)("");
    const [applyVoucher, setApplyVoucher] = (0,react.useState)(null);
    const [loadingVoucher, setLoadingVoucher] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    (0,react.useEffect)(()=>{
        const layoutDiv = document.getElementById("layout");
        if (layoutDiv) layoutDiv.style.overflow = "initial";
    }, []);
    const checkVoucher = async (value)=>{
        if (!!value) {
            setLoadingVoucher(true);
            try {
                var _router_query, _selectedData_selectMethod, _selectedData_selectPackage, _selectedData_selectMethod1, _selectedData_selectMethod_item, _selectedData_selectUser, _selectedData_selectServer, _selectedData_selectRole, _selectedData_selectPlatform, _res_data;
                let body = {
                    slug_name: String(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name),
                    method: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : _selectedData_selectMethod.method,
                    v3_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPackage = selectedData.selectPackage) === null || _selectedData_selectPackage === void 0 ? void 0 : _selectedData_selectPackage.v3_id,
                    package_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod1 = selectedData.selectMethod) === null || _selectedData_selectMethod1 === void 0 ? void 0 : (_selectedData_selectMethod_item = _selectedData_selectMethod1.item) === null || _selectedData_selectMethod_item === void 0 ? void 0 : _selectedData_selectMethod_item.package_id,
                    user_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectUser = selectedData.selectUser) === null || _selectedData_selectUser === void 0 ? void 0 : _selectedData_selectUser.user_id,
                    server_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectServer = selectedData.selectServer) === null || _selectedData_selectServer === void 0 ? void 0 : _selectedData_selectServer.server_id,
                    role_id: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectRole = selectedData.selectRole) === null || _selectedData_selectRole === void 0 ? void 0 : _selectedData_selectRole.role_id,
                    voucher_code: value,
                    type: "check_voucher"
                };
                if (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform = selectedData.selectPlatform) === null || _selectedData_selectPlatform === void 0 ? void 0 : _selectedData_selectPlatform.platform_id) {
                    var _selectedData_selectPlatform1;
                    body = {
                        ...body,
                        platform: selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectPlatform1 = selectedData.selectPlatform) === null || _selectedData_selectPlatform1 === void 0 ? void 0 : _selectedData_selectPlatform1.platform_id
                    };
                }
                const res = await TopupService/* default.submitDoTopup */.Z.submitDoTopup(body);
                if ((res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.errorCode) === 0) {
                    var _res_data1;
                    setApplyVoucher(res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : _res_data1.data);
                    setSelectedData({
                        ...selectedData,
                        voucher_code: value
                    });
                    setErrorCode("");
                } else {
                    var _res_data2;
                    setErrorCode(res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : _res_data2.message);
                }
            } catch (err) {
                if (err.data.errorCode === 15) {
                    setVisible(true);
                } else {
                    var _err_data;
                    setErrorCode(err === null || err === void 0 ? void 0 : (_err_data = err.data) === null || _err_data === void 0 ? void 0 : _err_data.message);
                }
            } finally{
                setLoadingVoucher(false);
            }
            setLoadingVoucher(false);
        }
    };
    (0,react.useEffect)(()=>{
        var _selectedData_selectMethod;
        if ((selectedData === null || selectedData === void 0 ? void 0 : selectedData.selectPackage.v3_id) && (selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : _selectedData_selectMethod.method)) {
            setErrorCode("");
            setApplyVoucher(null);
            setLoadingVoucher(false);
            setSelectedData({
                ...selectedData,
                voucher_code: ""
            });
        }
    }, [
        selectedData === null || selectedData === void 0 ? void 0 : selectedData.selectPackage.v3_id,
        selectedData === null || selectedData === void 0 ? void 0 : (_selectedData_selectMethod = selectedData.selectMethod) === null || _selectedData_selectMethod === void 0 ? void 0 : _selectedData_selectMethod.method
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative max-w-[1280px] w-full mx-auto md:mt-[64px] flex gap-[40px] lg:gap-[80px] flex-col lg:flex-row overflow-initial",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PackageAndMethod, {
                    packageAndTab: packageAndTab,
                    selectedTab: selectedTab,
                    handleChangeSelectedTab: handleChangeSelectedTab,
                    selectedData: selectedData,
                    setSelectedData: setSelectedData,
                    setLoading: setLoading,
                    loading: loading,
                    renderMethods: renderMethods,
                    setRenderMethods: setRenderMethods,
                    extendData: extendData,
                    listPackageType: listPackageType,
                    gameDetail: gameDetail
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:max-w-[463px] w-full hidden md:block lg:sticky lg:top-[95px] h-fit right-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopupOrderInfo, {
                    selectedData: selectedData,
                    loadingCallingMethod: loading,
                    setVisible: setVisible,
                    setSelectedData: setSelectedData,
                    setErrorCode: setErrorCode,
                    errorCode: errorCode,
                    applyVoucher: applyVoucher,
                    loadingVoucher: loadingVoucher,
                    checkVoucher: checkVoucher,
                    setApplyVoucher: setApplyVoucher
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopupOrderInfoMobile, {
                    selectedData: selectedData,
                    setSelectedData: setSelectedData,
                    loadingCallingMethod: loading,
                    renderMethods: renderMethods,
                    setVisible: setVisible,
                    setErrorCode: setErrorCode,
                    errorCode: errorCode,
                    applyVoucher: applyVoucher,
                    loadingVoucher: loadingVoucher,
                    checkVoucher: checkVoucher,
                    setApplyVoucher: setApplyVoucher
                })
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePhoneModal/* UpdatePhoneModal */.S, {
                visible: visible,
                setVisible: setVisible
            })
        ]
    });
};

;// CONCATENATED MODULE: ./app/containers/topup/detail/TopupDetailTab.tsx




const TopupDetailTab = (param)=>{
    let { currentStep , selectedData , listStep  } = param;
    const [percent, setPercent] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    const renderCheckStep = (step)=>{
        if (step === TOPUP_STEP.CONFIRM_ID) {
            if (selectedData.selectServer.server_id && selectedData.selectRole.role_id) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 bg-main-01 rounded-[24px] flex items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13.8593 4.2186L6.17968 12.5143C6.1351 12.5625 6.08217 12.6007 6.0239 12.6268C5.96563 12.6529 5.90317 12.6663 5.8401 12.6663C5.77702 12.6663 5.71456 12.6529 5.65629 12.6268C5.59802 12.6007 5.54509 12.5625 5.50051 12.5143L2.14066 8.88492C2.0506 8.78763 2 8.65568 2 8.5181C2 8.38051 2.0506 8.24856 2.14066 8.15127C2.23072 8.05398 2.35288 7.99933 2.48025 7.99933C2.60761 7.99933 2.72977 8.05398 2.81983 8.15127L5.8401 11.4145L13.1802 3.48495C13.2702 3.38766 13.3924 3.33301 13.5198 3.33301C13.6471 3.33301 13.7693 3.38766 13.8593 3.48495C13.9494 3.58224 14 3.71419 14 3.85178C14 3.98936 13.9494 4.12131 13.8593 4.2186Z",
                            fill: "#FAF8FF"
                        })
                    })
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 dark:bg-neutral-07 bg-neutral-09 rounded-[24px] flex items-center justify-center text-[14px] text-main-white",
                    children: step
                });
            }
        }
        if (step === TOPUP_STEP.PACKAGE_METHOD && step === currentStep) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 bg-main-01 rounded-[24px] flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.8593 4.2186L6.17968 12.5143C6.1351 12.5625 6.08217 12.6007 6.0239 12.6268C5.96563 12.6529 5.90317 12.6663 5.8401 12.6663C5.77702 12.6663 5.71456 12.6529 5.65629 12.6268C5.59802 12.6007 5.54509 12.5625 5.50051 12.5143L2.14066 8.88492C2.0506 8.78763 2 8.65568 2 8.5181C2 8.38051 2.0506 8.24856 2.14066 8.15127C2.23072 8.05398 2.35288 7.99933 2.48025 7.99933C2.60761 7.99933 2.72977 8.05398 2.81983 8.15127L5.8401 11.4145L13.1802 3.48495C13.2702 3.38766 13.3924 3.33301 13.5198 3.33301C13.6471 3.33301 13.7693 3.38766 13.8593 3.48495C13.9494 3.58224 14 3.71419 14 3.85178C14 3.98936 13.9494 4.12131 13.8593 4.2186Z",
                        fill: "#FAF8FF"
                    })
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-[27px] h-[27px] border border-[3px] border-bg-light dark:border-bg-02 dark:bg-neutral-07 bg-neutral-09 rounded-[24px] flex items-center justify-center text-[14px] text-main-white",
            children: step
        });
    };
    (0,react.useEffect)(()=>{
        if (selectedData.selectUser.user_id) {
            setPercent(15);
        }
        if (selectedData.selectServer.server_id && selectedData.selectRole.role_id) {
            setPercent(40);
        }
        if (selectedData.selectPackage.v3_id && selectedData.selectMethod.key) {
            setPercent(75);
        }
    }, [
        selectedData
    ]);
    (0,react.useEffect)(()=>{
        setPercent(0);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:flex max-w-[420px] w-full mx-auto justify-between relative hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-neutral-09 dark:bg-neutral-07 h-[1.5px] absolute z-1 w-full top-[14px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-main-01 h-full",
                    style: {
                        width: "".concat(percent, "%")
                    }
                })
            }),
            listStep.map((item)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative z-2",
                    children: [
                        renderCheckStep(item.step),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "whitespace-nowrap absolute left-[50%] translate-x-[-50%] translate-y-[-50%] top-[40px] text-[16px] Nunito-600 ".concat(currentStep >= item.step ? "text-main-01" : "text-neutral dark:text-neutral-07"),
                            children: item.title
                        })
                    ]
                }, item.step);
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/header-custom-mb/index.tsx
var header_custom_mb = __webpack_require__(76912);
// EXTERNAL MODULE: ./app/services/services/index.ts + 2 modules
var services = __webpack_require__(27020);
// EXTERNAL MODULE: ./public/img/store/icon_la.png
var icon_la = __webpack_require__(81622);
// EXTERNAL MODULE: ./app/services/query-fn/topup/index.ts + 2 modules
var topup = __webpack_require__(74046);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./app/services/query-fn/game/index.ts + 1 modules
var query_fn_game = __webpack_require__(82190);
// EXTERNAL MODULE: ./app/services/query-fn/index.ts + 6 modules
var query_fn = __webpack_require__(58512);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./app/containers/topup/index.tsx




















const initSelectedData = {
    selectMethod: {},
    selectUser: {
        user_id: "",
        username: ""
    },
    selectServer: {
        server_id: "",
        server_name: ""
    },
    selectRole: {
        role_id: "",
        role_name: ""
    },
    country_code: "",
    selectPlatform: {
        platform_id: "",
        platform_name: ""
    },
    selectPackage: {},
    hoverDescription: ""
};
const GAME_ID_TIEU_NGAO = "GMA202306";
const TopupContainer = (param)=>{
    let { gameDetail  } = param;
    var _router_query, _router_query1, _router_query2, _router_query3, _listStep_find, _router_query4, _router_query5, _listNotPopup_, _listNotPopup_1, _listNotPopup_2, _listNotPopup_3, _router_query6, _userInfo_total_la, _ref;
    const { userInfo , setOpenModal  } = (0,react.useContext)(context/* AppContext */.Il);
    const [step, setStep] = (0,react.useState)(TOPUP_STEP.CONFIRM_ID);
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [selectedData, setSelectedData] = (0,react.useState)(initSelectedData);
    const [sourcePackageAndTab, setSourcePackageAndTab] = (0,react.useState)();
    const [selectedTab, setSelectedTab] = (0,react.useState)(undefined);
    const [visible, setVisible] = (0,react.useState)(false);
    const { mutate: loginSDKFromGamotaId , isPending: isLoginSDKFromGamotaIdPending  } = (0,query_fn/* useMutationLoginSDK */.j_)();
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { data: listGameBanner  } = (0,query_fn_game/* useQueryGetListGameBanner */.LI)({
        type: "store"
    });
    const token = configs/* isClient */.C5 ? window.localStorage.getItem("token") : "";
    const listNotPopup = (0,react.useMemo)(()=>{
        if (!listGameBanner || !(listGameBanner === null || listGameBanner === void 0 ? void 0 : listGameBanner.length)) {
            return [];
        }
        return listGameBanner === null || listGameBanner === void 0 ? void 0 : listGameBanner.filter((item)=>!item.open_popup);
    }, [
        listGameBanner
    ]);
    const { themeApp  } = (0,react.useContext)(context/* AppContext */.Il);
    const { data , isLoading  } = (0,topup/* useQueryGetListTopup */.Qi)();
    const [game, setGame] = (0,react.useState)({
        game_id: "",
        game_name: "",
        icon: "",
        slug_name: router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name
    });
    const [extendData, setExtendData] = (0,react.useState)();
    const [listPackageType, setListPackageType] = (0,react.useState)("text");
    (0,react.useEffect)(()=>{
        if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
            const _game = OptionGame === null || OptionGame === void 0 ? void 0 : OptionGame.find((item)=>{
                var _router_query;
                return (item === null || item === void 0 ? void 0 : item.slug_name) === (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name);
            });
            setGame(_game);
        }
    }, [
        data
    ]);
    const OptionGame = !!data ? data : [];
    const onChangeGame = (value)=>{
        const _game = OptionGame === null || OptionGame === void 0 ? void 0 : OptionGame.find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.game_id) === value;
        });
        router.push({
            pathname: "/topup/[slug_name]",
            query: {
                slug_name: _game.slug_name
            }
        });
        setGame(_game);
    };
    const [loadingCallingMethod, setLoadingCallingMethod] = (0,react.useState)(false);
    const handleSetExtendData = (value)=>{
        setExtendData(value);
    };
    const handleChangeSelectedTab = (tab)=>{
        !loadingCallingMethod && setSelectedTab(tab);
    };
    const listStep = [
        {
            title: t("store.topup_confirm_id"),
            step: TOPUP_STEP.CONFIRM_ID
        },
        {
            title: t("topup.select_method"),
            step: TOPUP_STEP.PACKAGE_METHOD
        },
        {
            title: t("store.topup_payment"),
            step: TOPUP_STEP.CHECKOUT
        }
    ];
    const renderStep = (0,react.useMemo)(()=>{
        switch(step){
            case TOPUP_STEP.CONFIRM_ID:
                var _gameDetail_last_transaction, _gameDetail_last_transaction1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmIdStep, {
                    gameDetail: {
                        ...gameDetail,
                        user: {
                            user_id: (gameDetail === null || gameDetail === void 0 ? void 0 : (_gameDetail_last_transaction = gameDetail.last_transaction) === null || _gameDetail_last_transaction === void 0 ? void 0 : _gameDetail_last_transaction.user_id) || "",
                            username: (gameDetail === null || gameDetail === void 0 ? void 0 : (_gameDetail_last_transaction1 = gameDetail.last_transaction) === null || _gameDetail_last_transaction1 === void 0 ? void 0 : _gameDetail_last_transaction1.username) || ""
                        },
                        servers: {}
                    },
                    selectedData: selectedData,
                    setSelectedData: setSelectedData,
                    setSelectedTab: setSelectedTab,
                    setSourcePackageAndTab: setSourcePackageAndTab,
                    setStep: setStep,
                    handleSetExtendData: handleSetExtendData,
                    setListPackageType: setListPackageType
                });
            default:
                return sourcePackageAndTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondStep, {
                    packageAndTab: sourcePackageAndTab,
                    selectedTab: selectedTab,
                    handleChangeSelectedTab: handleChangeSelectedTab,
                    selectedData: selectedData,
                    setSelectedData: setSelectedData,
                    loading: loadingCallingMethod,
                    setLoading: setLoadingCallingMethod,
                    extendData: (gameDetail === null || gameDetail === void 0 ? void 0 : gameDetail.game_id) === GAME_ID_TIEU_NGAO ? extendData : null,
                    listPackageType: listPackageType,
                    gameDetail: gameDetail
                }) : null;
        }
    }, [
        step,
        gameDetail,
        selectedData,
        sourcePackageAndTab,
        selectedTab,
        handleChangeSelectedTab,
        loadingCallingMethod,
        extendData
    ]);
    const onClose = ()=>{
        var _window_history;
        if (((_window_history = window.history) === null || _window_history === void 0 ? void 0 : _window_history.length) && window.history.length > 1) {
            router.back();
        } else {
            router.push("/store");
        }
    };
    (0,react.useEffect)(()=>{
        if (router.query.slug_name) {
            setSelectedData(initSelectedData);
            setStep(TOPUP_STEP.CONFIRM_ID);
            setSourcePackageAndTab(undefined);
            setSelectedTab(undefined);
            setExtendData(undefined);
        }
        if (router.query.slug_name === "napla") {
            setSelectedData({
                ...selectedData,
                selectUser: {
                    user_id: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid,
                    username: userInfo === null || userInfo === void 0 ? void 0 : userInfo.username
                },
                selectServer: {
                    server_id: "napla",
                    server_name: "napla"
                },
                selectRole: {
                    role_id: "napla",
                    role_name: "napla"
                }
            });
        }
    }, [
        router.query.slug_name,
        userInfo,
        gameDetail
    ]);
    const onLoginBySdk = (access_token)=>{
        if (!!access_token) {
            loginSDKFromGamotaId({
                access_token: access_token
            }, {
                onSuccess: (dataSuccess)=>{
                    var _dataSuccess_data;
                    const res = dataSuccess === null || dataSuccess === void 0 ? void 0 : (_dataSuccess_data = dataSuccess.data) === null || _dataSuccess_data === void 0 ? void 0 : _dataSuccess_data.data;
                    if (!!(res === null || res === void 0 ? void 0 : res.access_token)) {
                        localStorage.setItem("token", res === null || res === void 0 ? void 0 : res.access_token);
                        queryClient.invalidateQueries({
                            queryKey: [
                                configs/* QUERY_KEY.PROFILE_INFO */.lP.PROFILE_INFO
                            ],
                            refetchType: "active"
                        });
                        router.push({
                            pathname: router.pathname,
                            query: {
                                slug_name: router.query.slug_name
                            }
                        });
                    }
                },
                onError: (errorMessage)=>{
                    setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL);
                    router.push({
                        pathname: router.pathname,
                        query: {
                            slug_name: router.query.slug_name
                        }
                    });
                }
            });
        }
    };
    (0,react.useEffect)(()=>{
        var _router_query;
        if ((router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.update) === "1") {
            services/* UserService.getReloadProfile */.K.getReloadProfile();
        }
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        var _router_query;
        if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone) && (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.update) !== "1") {
        // setVisible(true)
        }
    }, [
        router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.update,
        userInfo
    ]);
    (0,react.useEffect)(()=>{
        var _router_query;
        if (!!(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.access_token)) {
            var _router_query1, _router_query_access_token;
            onLoginBySdk((router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : (_router_query_access_token = _router_query1.access_token) === null || _router_query_access_token === void 0 ? void 0 : _router_query_access_token.toString()) || "");
        }
    }, [
        router === null || router === void 0 ? void 0 : (_router_query2 = router.query) === null || _router_query2 === void 0 ? void 0 : _router_query2.access_token
    ]);
    (0,react.useEffect)(()=>{
        if (!token && !router.query.access_token) {
            setOpenModal(configs/* OPEN_MODAL.LOGIN_MODAL */.a6.LOGIN_MODAL);
        }
    }, [
        setOpenModal,
        token,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_custom_mb/* default */.Z, {
                isInpage: true,
                heading: ((_router_query3 = router.query) === null || _router_query3 === void 0 ? void 0 : _router_query3.slug_name) === "napla" ? t("store.la_invoice") : (_listStep_find = listStep.find((item)=>{
                    return (item === null || item === void 0 ? void 0 : item.step) === step;
                })) === null || _listStep_find === void 0 ? void 0 : _listStep_find.title,
                action: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[1280px] mx-auto min-h-[90dvh] md:min-h-0 flex flex-col ".concat(((_router_query4 = router.query) === null || _router_query4 === void 0 ? void 0 : _router_query4.slug_name) === "napla" ? "md:mt-[40px]" : "md:mt-[64px]"),
                children: [
                    !!(listNotPopup === null || listNotPopup === void 0 ? void 0 : listNotPopup.length) && ((_router_query5 = router.query) === null || _router_query5 === void 0 ? void 0 : _router_query5.slug_name) !== "napla" && step === TOPUP_STEP.CONFIRM_ID && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-[500px] w-full mx-auto mb-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: ((_listNotPopup_ = listNotPopup[0]) === null || _listNotPopup_ === void 0 ? void 0 : _listNotPopup_.click_url) ? (_listNotPopup_1 = listNotPopup[0]) === null || _listNotPopup_1 === void 0 ? void 0 : _listNotPopup_1.click_url : "/store",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: ((_listNotPopup_2 = listNotPopup[0]) === null || _listNotPopup_2 === void 0 ? void 0 : _listNotPopup_2.banner_app) || ((_listNotPopup_3 = listNotPopup[0]) === null || _listNotPopup_3 === void 0 ? void 0 : _listNotPopup_3.banner),
                                className: "w-full aspect-[3/1] object-cover rounded-2xl"
                            })
                        })
                    }),
                    ((_router_query6 = router.query) === null || _router_query6 === void 0 ? void 0 : _router_query6.slug_name) === "napla" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex justify-between items-center mb-[24px] hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center bg-white border border-black/10 rounded-[12px] p-[8px] pr-[16px] dark:bg-white/10 dark:border-neutral-03",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: icon_la/* default.src */.Z.src,
                                        className: "w-[32px] h-[32px] mr-[8px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16p] Nunito-700",
                                        children: t("store.la_invoice")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: icon_la/* default.src */.Z.src,
                                        className: "w-[20px] h-[20px] mr-[8px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[14px] Nunito-600 text-main-01 dark:text-main-disable",
                                        children: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_total_la = userInfo.total_la) === null || _userInfo_total_la === void 0 ? void 0 : _userInfo_total_la.toLocaleString()
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex max-w-[500px] w-full mx-auto justify-between items-center xs:mb-[24px] mb-[32px] gap-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* Select */.Ph, {
                                value: (game === null || game === void 0 ? void 0 : game.game_id) || "",
                                onValueChange: (value)=>onChangeGame(value),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative xs:flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_select/* SelectTrigger */.i4, {
                                            asChild: false,
                                            className: "px-[12px] xs:px-[6px] h-[64px] xs:h-[48px] border-stroke rounded-[12px] bg-white dark:bg-bg-disable/10 flex gap-[4px] items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectValue */.ki, {
                                                    placeholder: t("common.chose_game"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center flex-1 gap-4 xs:gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: game === null || game === void 0 ? void 0 : game.icon,
                                                                alt: game === null || game === void 0 ? void 0 : game.game_name,
                                                                className: "w-[40px] h-[40px] xs:w-[30px] xs:h-[30px] rounded-[12px] xs:rounded-[8px]"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[16px] xs:text-[14px] line-clamp-1",
                                                                children: (game === null || game === void 0 ? void 0 : game.game_name) || ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "24",
                                                    height: "24",
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M5.8335 8.3335L10.0002 11.6668L14.1668 8.3335",
                                                        stroke: themeApp === "dark" ? "#FAF8FF" : "#100D28",
                                                        strokeWidth: "1.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_select/* SelectContent */.Bw, {
                                        align: "end",
                                        className: "p-1 rounded-[16px]",
                                        children: OptionGame && ((_ref = [
                                            ...OptionGame.sort((a, b)=>a.game_name.localeCompare(b.game_name))
                                        ]) === null || _ref === void 0 ? void 0 : _ref.map((item)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui_select/* SelectItem */.Ql, {
                                                value: item === null || item === void 0 ? void 0 : item.game_id,
                                                className: "p-[6px] h-[36px] rounded-[12px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-[6px]",
                                                    title: item === null || item === void 0 ? void 0 : item.game_name,
                                                    children: [
                                                        (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: item === null || item === void 0 ? void 0 : item.icon,
                                                            alt: item === null || item === void 0 ? void 0 : item.game_name,
                                                            className: "w-[24px] h-[24px] rounded-[6px]"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "flex-1 line-clamp-1",
                                                            children: item === null || item === void 0 ? void 0 : item.game_name
                                                        })
                                                    ]
                                                })
                                            }, item === null || item === void 0 ? void 0 : item.game_id);
                                        }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/user/".concat((userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias) ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.alias : userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid, "?tab=transaction-manager&type=topup-all"),
                                className: "flex items-center gap-2 xs:gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] Nunito-600 xs:text-[14px] text-main-01",
                                        children: t("profile.transaction_history")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "25",
                                        viewBox: "0 0 24 25",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M14 16.1L18 12.1M18 12.1L14 8.09998M18 12.1L6 12.1",
                                            stroke: "#3263E4",
                                            strokeWidth: "1.5",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopupDetailTab, {
                        currentStep: step,
                        selectedData: selectedData,
                        listStep: listStep
                    }),
                    renderStep,
                    visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePhoneModal/* UpdatePhoneModal */.S, {
                        visible: visible,
                        setVisible: setVisible
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/topup/[slug_name]/index.tsx







const TopupGameDetailPage = ()=>{
    var _router_query;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const [gameDetail, setGameDetail] = (0,react.useState)();
    const [maintain, setMaintain] = (0,react.useState)(false);
    const getData = async (slug_name)=>{
        try {
            const { data  } = await TopupService/* default.getInfoGameDetail */.Z.getInfoGameDetail(slug_name);
            if (data === null || data === void 0 ? void 0 : data.data) {
                setGameDetail(data === null || data === void 0 ? void 0 : data.data);
            }
            console.log(data);
            if (data.errorCode === 33) {
                setMaintain(true);
            }
        } catch (e) {
            if (e.data.errorCode === 33) {
                setMaintain(true);
            }
        }
    };
    (0,react.useEffect)(()=>{
        var _router_query;
        if (!!(router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name)) {
            var _router_query1;
            getData(String(router === null || router === void 0 ? void 0 : (_router_query1 = router.query) === null || _router_query1 === void 0 ? void 0 : _router_query1.slug_name));
        }
    }, [
        router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.slug_name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            gameDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopupContainer, {
                gameDetail: gameDetail
            }),
            maintain && /*#__PURE__*/ (0,jsx_runtime.jsx)(MaintainScreen, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_name_ = ((0,esm/* withTranslation */.Zh)("common")(TopupGameDetailPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,179], function() { return __webpack_exec__(34877); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);